/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect,useRef } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import classnames from "classnames";
import NumberFormat from "react-number-format";
import axiosInstance from "./../../helpers/axiosInstance";
import Skeleton from "react-loading-skeleton";
import Slicer from "react-slicer";
import "react-slicer/build/react-slicer.css";
import IconTid from '../../assets/img/icons/Icono-Tipo-de-documento-Gris.png'
import iconoInscripA from "../../assets/img/icons/Icono-Inscribir-Contacto-Verde.png"
import iconoInscrip from "../../assets/img/icons/Icono-Inscribir-Contacto-Gris.png"
import iconoContactInscripA from "../../assets/img/icons/Icono-Contactos-Inscritos-Verde.png"
import iconoContactInscrip from "../../assets/img/icons/Icono-Contactos-Inscritos-Gris.png"
import iconoMasiveA from "../../assets/img/icons/Icono-Contactos-Inscritos-Verde.png"
import iconoMasive from "../../assets/img/icons/Icono-Contactos-Inscritos-Gris.png"
import MassiveContactCharge from "./MassiveContactCharge.js"
import ModificarContacto from "./ModificaContacto";
import exitoCreacion from '../../assets/img/illustrations/add-contact-success.svg';


// reactstrap components
import {
  Card,
  NavLink,
  CardBody,
  Container,
  Row,
  Col,
  Nav,
  Modal,
  NavItem,
  TabPane,
  TabContent,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
} from "reactstrap";
import {useDispatch} from "react-redux";
import {cambiaruta,cambiasidebar,desactivasidebar} from "../../Slicersreducers";

function Contacts(props) {
  const listStep = [
    { title: "Contacto" },
    { title: "Cuenta" },
    { title: "Verificación" },
  ];

  const [tabToGo, setTabToGo] = useState(0);

  const [tabs, setTabs] = useState(0);
  const [typesDocument, setTypesDocument] = useState("1");
  const [types, setTypes] = useState("1");

  const [cancelationModal, setCancelationModal] = useState(false);
  const [cancelationEliminaModal, setCancelationEliminaModal] = useState(false);
  const [resultModal, setResultModal] = useState(false);
  const [contactoEliminar, setContactoEliminar] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [listAlert, setListAlert] = useState([]);
  
  const [step, setStep] = useState(0);
  const [color,setColor] = useState("text-gray-dark");
  const [iconInscrip,setIconInscrip] = useState(iconoInscrip);
  const [colorContact,setColorContact] = useState("text-gray-dark");
  const [iconContactInscrip,setIconContactInscrip] = useState(iconoContactInscrip);
  const [colorMasive,setColorMasive] = useState("text-gray-dark");
  const [iconMasiveContact,setIconMasiveContact] = useState(iconoMasive);
  const [stepLine, setStepLine] = useState(0);
  const [activeInsCont,setActiveInsCont] = useState(false);
  const [activeContInscritos,setActiveContInscritos] = useState(false);
  const [exitoElimina,setExitoElimina]=useState(false);
  const [baseBanco,setBaseBanco] = useState([]);
  const [relatedAccounts, setRelatedAccounts] = useState([]);
  const [contact, setContact] = useState({});
  const [account, setAccount] = useState({});

  const [isLoadingContacts, setIsLoadingContacts] = useState(true);
  const dispatch=useDispatch();

  var createReactClass = require("create-react-class");
  const [tidelec,settidelec]=useState([false,false,false,false,false,false,false]);
  
  //const [auxNid, setAuxNid] = useState(this.props.data.id);
  const [infContModif,setinfContModif]=useState({
    aliasAccount: "",
    bankCode: "",
    city: "",
    id: "",
    indicatorAction: "",
    numeroCuenta: "",
    ownerAccount: "",
    sequence: "",
    status: "",
    tipoCuenta: "",
    typeID: ""
  });
  const refNid=useRef(null);

  //Build Contact
  var auxBuildContact = {
    tid: "",
    nid: "",
    name: "",
  };
  const NIDChange = (event) => {
    //infContModif.id = event.target.value;
    //event.preventDefault();
    auxBuildContact.nid = event.target.value;
    //setAuxNid(event.target.value);
    //refNid.current.value = "444"
    //refNid.current.focus();
  };

  const NameChange = (event) => {
    auxBuildContact.name = event.target.value;
  };

  async function BuildContact() {
    auxBuildContact.tid = typesDocument;
    await setContact(auxBuildContact);
    console.log(auxBuildContact)
    setStep((s) => s + 1);
  }
  const terminaEliminaContact=()=>{
    console.log("termina modifica")
    setExitoElimina(false);
    eliminaCont();
  }

  // Build Account
  var auxBuildAccount = {
    accountType: "",
    accountNumber: "",
    bank: "1",
    city: "5001",
    nickname: "",
  };

  const AccountNumberChange = (event) => {
    auxBuildAccount.accountNumber = event.target.value;
  };

  const BankChange = (event) => {
    auxBuildAccount.bank = event.target.value;
  };

  const CityChange = (event) => {
    auxBuildAccount.city = event.target.value;
  };

  const NicknameChange = (event) => {
    auxBuildAccount.nickname = event.target.value;
  };

  async function BuildAccount() {
    auxBuildAccount.accountType = types;
    await setAccount(auxBuildAccount);
    console.log(auxBuildAccount)
    setStep((s) => s + 1);
    
  }
  const handleSubmit = async(e) => {
    e.preventDefault();
    BuildContact()
  };
  const handleSubmit2 = async(e) => {
    e.preventDefault();
    BuildAccount()
  };

  //Add Related Account
  const AddRelatedAccount = async (event) => {
    const relatedAccount = {
      TipoCuenta: account.accountType,
      NumeroCuenta: account.accountNumber,
      BankCode: account.bank.split("_")[0],
      City: account.city.split("_")[0],
      TypeID: contact.tid,
      ID: contact.nid,
      OwnerAccount: contact.name,
      AliasAccount: account.nickname,
      IndicatorAction: "CREAR",
    };
    console.log(relatedAccount);

    const request = await axiosInstance().post("/WSGYG39_2/api/Consultas/CreateRelatedAccounts", relatedAccount)
      .catch((err) => {
        
        setListAlert(
          err.response.data.errors.map((o) => ({
            ...o,
            type: "alert alert-alert show alert-dismissible fade alert-danger",
            icon: "fas fa-exclamation-circle",
          }))
        );
        return 'err';
      });
    if (request != "err") {
      setResultModal(true);
      console.log(request.data);
    }
  };

  //Get Related Accounts
  const GetRelatedAccount = async (event) => {
    setIsLoadingContacts(true);
    const request = await axiosInstance()
      .get("/WSGYG39_2/api/Consultas/AssociatedAccounts")
      .catch((err) => {
        setIsLoadingContacts(false);
        return "err";
      });
    if (request != "err") {
      setIsLoadingContacts(false);
      console.log(request.data);
      setRelatedAccounts(request.data.relatedAccounts);
    }
  };

  //Navigation Buttons
  async function goBack(tab, isFirst) {
    if (!isFirst) {
      await setStep((s) => s - 1);
    } else {
      setCancelationModal(true);
      await setTabToGo(0);
    }
  }

  // //TypeDocument
  // async function getTypeDocument(type) {
  //   //auxBuildAccount.accountType = type;
  //   await setTypesDocument(type);
  // }

  function getTypeDocument(event) {
    //auxBuildAccount.accountType = type;
    //setNewUser({...newUser, TidUser: type});
    setTypesDocument(event.target.value);
    console.log(event.target.value);
      switch(event.target.value){
        case "1":
          settidelec([true,false,false,false,false,false,false]);

          break;
        case "2":
          settidelec([false,true,false,false,false,false,false]);

          break;
        case "3":
            settidelec([false,false,true,false,false,false,false]);

        break;
        case "5":
          settidelec([false,false,false,true,false,false,false]);

        break;
        case "6":
          settidelec([false,false,false,false,true,false,false]);

        break;
        case "8":
          settidelec([false,false,false,false,false,true,false]);

        break;
        case "9":
          settidelec([false,false,false,false,false,false,true]);
        break;

      }
  }

  //Type Account
  async function getTypeAccount(type) {
    //auxBuildAccount.accountType = type;
    await setTypes(type);
  }

  // Stepper
  function DivStep({ children }) {
    return <>{children}</>;
  }

  function Progress(props) {
    const styleProgress = { width: 100 / props.list.length - 2 + "%" };
    var newsTemplate = props.list.map(function (item, index) {
      if (index === props.current) {
        return (
          <div
            key={index}
            className="progress-bar-step-active"
            style={styleProgress}
          >
            <span className="stepper-number-active">
              <span className="stepper-label-active">{index + 1}</span>
            </span>
          </div>
        );
      } else {
        return (
          <div key={index} className="progress-bar-step" style={styleProgress}>
            <span className="stepper-number">
              <span className="stepper-label">{index + 1}</span>
            </span>
          </div>
        );
      }
    });
    return newsTemplate;
  }

  function LineStepper(props) {
    return (
      <>
        <div style={{ position: "relative" }} className="mt-1 m-4 mb-6">
          <div style={{ position: "absolute", width: "100%" }}>
            <Progress current={props.current} list={props.listStep}></Progress>
          </div>
        </div>
      </>
    );
  }
  const [maxstepcreaCont,setmaxstepcreaCont]=useState(0);
  const controlesCreaCont=(etapa,sentido)=>{
    console.log("etapa " + etapa + " sentido " + sentido);
    console.log(maxstepcreaCont)
    if(sentido==1){
      if(etapa+1 <= maxstepcreaCont && etapa>0){
        if(etapa<2){
          setStep((s) => s + 1);
        }else{
            if(etapa+2 <= maxstepcreaCont){
              setStep((s) => s + 2);
            }
          }
        }
      }else{
      if(etapa-1 >=0){
        if(etapa<3){
          setStep((s) => s - 1);
        }else{
            setStep((s) => s - 2);
          }
        }
      }
    }
    const infContCancel = () => {
      setTabs(2)
      GetRelatedAccount();
    }
    const eliminaCont = () => {
      setTabs(2)
    }

    const enviacancelacionM=()=>{
      console.log("envia cancela modificacion");
      
      setTabs(0);
    }

  
  function NavigationButtons(props) {
    var isFirst=true;
    if(props.step > 0){
      isFirst=false;}
    var isEnd = props.step === props.listStep.length - 1;
    return (
      <div>
      <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
          <button className="btn-icon bg-white text-green btn" onClick={enviacancelacionM}>Cancelar</button>
        </div>
      <div style={{ justifyContent: "space-between", display: "flex" }}>
        <button class="btn-icon text-dark-grey btn" disabled={isFirst} onClick={()=>{controlesCreaCont(step,-1)}}>
          <span class="btn-inner--icon">
            {'<'}
          </span>
          <span class="btn-inner--text">{isFirst?'Volver':props.listStep[props.step-1].title}</span>
        </button>
        <button class="btn-icon text-dark-grey btn" disabled={isEnd} onClick={()=>{controlesCreaCont(step,1)}}>
          <span class="btn-inner--text">{isEnd?'Cancelar':props.listStep[props.step+1].title}</span>
          <span class="btn-inner--icon">
            {'>'}
          </span>
        </button>
      </div>
      </div>
    );
  };

  function DivStepper({ children, ...props }) {
    const childrenArray = React.Children.toArray(children);

    const currentChild = childrenArray[props.step];
    return (
      <div {...props}>
        <NavigationButtons
          tab={props.tab}
          step={props.step}
          listStep={props.listStep}
        ></NavigationButtons>
        <LineStepper
          current={props.step}
          listStep={props.listStep}
        ></LineStepper>
        {currentChild}
      </div>
    );
  }
  const modificaContacto=(contacto)=>{
    //refNid.current.value = contacto.id;
    
    switch(contacto.typeID){
      case "1":
        settidelec([true,false,false,false,false,false,false]);

        break;
      case "2":
        settidelec([false,true,false,false,false,false,false]);

        break;
      case "3":
          settidelec([false,false,true,false,false,false,false]);

      break;
      case "5":
        settidelec([false,false,false,true,false,false,false]);

      break;
      case "6":
        settidelec([false,false,false,false,true,false,false]);

      break;
      case "8":
        settidelec([false,false,false,false,false,true,false]);

      break;
      case "9":
        settidelec([false,false,false,false,false,false,true]);
      break;

    }
    setinfContModif(contacto)
    console.log(contacto)
    setTabs(4);
    dispatch(cambiaruta("Inicio/Contactos/Contactos Inscritos"))
  }
  const ejecutasalirEliminaModal=()=>{
    setExitoElimina(false);
  }
  const ejecutasalirCancelationEliminaModal=()=>{
    setCancelationEliminaModal(false);
  }
  const eliminaContacto=async()=>{
    let contacto = contactoEliminar;
    console.log(account)
    auxBuildAccount.accountType = types;
    await setAccount(auxBuildAccount);
    console.log(auxBuildAccount)
  const relatedAccount = {
    TipoCuenta: contacto.accountType,
    NumeroCuenta: contacto.accountNumber,
    BankCode: contacto.bank,
    City: contacto.city,
    TypeID: contacto.tid,
    ID: contacto.nid,
    Sequence:contacto.sequence,
    OwnerAccount: contacto.name,
    AliasAccount: contacto.nickname,
    IndicatorAction: "ELIMINAR"
  };
  console.log(relatedAccount);
  setIsLoading(true);
  const request = await axiosInstance().post("/WSGYG39_2/api/Consultas/CreateRelatedAccounts", relatedAccount)
    .catch((err) => {
      setListAlert(
        err.response.data.errors.map((o) => ({
          ...o,
          type: "alert alert-alert show alert-dismissible fade alert-danger",
          icon: "fas fa-exclamation-circle",
        })));
    });
  if (request != "err") {
    //setResultModal(true);
    console.log("Eliminación Correcta");
    setIsLoading(false);
    setExitoElimina(true);
    GetRelatedAccount();
  }
  }
  //Paint Realted Accounts
  const GetInitial = (props) => {
    if (props.contact !== null) {
      var initial = props.contact.substr(0, 1);
      return (
        <div class="icon icon-shape bg-green text-white rounded-circle shadow">
          {initial}
        </div>
      );
    } else return "";
  };

  var RelatedAccount = createReactClass({
    render: function () {
      var ownerAccount = this.props.data.ownerAccount,
        aliasAccount = this.props.data.aliasAccount;
      return (
        <Col lg="12" xl="12" className="pt-3">
          <Card className="mb-xl-0 shadow">
            <CardBody className="">
              <Row>
                <div className="col-auto mr-3">
                  
                </div>
              <div className="" style={{display:"flex", flexDirection:"row", width:"100%", justifyContent:"space-between"}} >
                <div className="ml-3">
                  <Row>
                  <GetInitial contact={ownerAccount}></GetInitial>
                    <span class="mb-0 text-sm ml-2">{ownerAccount} <br /> {aliasAccount}</span>
                    
                  </Row>
                  <Row>
                    
                  </Row>
                </div>
                <div>
                      <button className="btn-icon bg-white text-green btn" onClick={()=>{modificaContacto(this.props.data)}} style={{fontSize:"10px",height:"25px", padding:"4px 1px 4px 1px"}}>Modificar</button>
                      <button className="btn-icon bg-white text-green btn" onClick={()=>{setContactoEliminar(this.props.data);setCancelationEliminaModal(true)}} style={{fontSize:"10px",height:"25px", padding:"4px 1px 4px 1px"}}>Eliminar</button>
                  </div>
              </div>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    },
  });
  const deleteAlert = (alert) => {
    setListAlert(listAlert.filter((auxAlert) => auxAlert != alert));
  };
  var Alerts = createReactClass({
    render: function () {
      var data = this.props.data;
      var newsTemplate;
      if (data.length > 0) {
        newsTemplate = data.map(function (item, index) {
          return (
            <div class={item.type} role="alert">
              <button
                type="button"
                class="close"
                aria-label="Close"
                onClick={() => deleteAlert(item)}
              >
                <span aria-hidden="true">×</span>
              </button>
              <span className="alert-inner--icon mr-3">
                <i className={item.icon} />
              </span>{" "}
              <span class="alert-inner--text">{item.description}</span>
            </div>
          );
        });
      }
      return <div className="toast-bottom-right">{newsTemplate}</div>;
    },
  });

  var RelatedAccounts = createReactClass({
    render: function () {
      var data = this.props.data;
      var newsTemplate;

      if (data.length > 0) {
        newsTemplate = data.map(function (item, index) {
          return (
            <Row key={index}>
              <RelatedAccount data={item} />
            </Row>
          );
        });
      } else if(isLoadingContacts) {
        newsTemplate = (
          <Skeleton
            height={100}
            count={5}
            className="card-transaction-info"
            style={{ width: "-webkit-fill-available" }}
          ></Skeleton>
        );
      }else {
        newsTemplate = <div className="text-center m-4">
          <h2 class="ml-2"> No cuentas con Cuentas Asociadas </h2>
        </div>;
      }
      return <div>{newsTemplate}</div>;
    },
  });
  const ejecutasalir=()=>{
    setCancelationModal(false);
  }
  
  const fetchJson = () => {
    fetch('../baseBancos.json')
  .then(response => {
      console.log(response)
      return response.json();
    }).then(data=> {
       console.log(data);
      setBaseBanco(data);
    }).catch((e) => {
      console.log("fetch" + e.message);
    });
  }
  //Use effect
  useEffect(() => {
    dispatch(cambiaruta("Inicio/Contactos"));
    dispatch(cambiasidebar(false));
    dispatch(desactivasidebar([false,false]))
    fetchJson();
  }, []);
  
  const cancelarMasivo = () => {
      setTabs(0)
      setColorMasive("text-gray-dark")
      setIconMasiveContact(iconoContactInscrip)
      
  }

  class NavsTransfer extends React.Component {
    toggleNavs = (e, state, index) => {
      e.preventDefault();
      if (index == 1) {
        setActiveInsCont(true)
        setActiveContInscritos(false)
        dispatch(cambiaruta("Inicio/Contactos/Inscribir Contacto"))
        setColor("text-green")
        setIconInscrip(iconoInscripA)
        setIconContactInscrip(iconoContactInscrip)
        setColorContact("text-gray-dark")
        setIconMasiveContact(iconoMasive)
        setColorMasive("text-gray-dark")
        
      }else if(index == 2){
        setActiveInsCont(false)
        setActiveContInscritos(true)
        dispatch(cambiaruta("Inicio/Contactos/Contactos Inscritos"))
        setColor("text-gray-dark")
        setIconInscrip(iconoInscrip)
        setIconContactInscrip(iconoContactInscripA)
        setColorContact("text-green")
        setIconMasiveContact(iconoMasive)
        setColorMasive("text-gray-dark")
      }else if(index == 3){
        setActiveInsCont(false)
        setActiveContInscritos(false)
        dispatch(cambiaruta("Inicio/Contactos/Cargues Masivos"))
        setColor("text-gray-dark")
        setIconInscrip(iconoInscrip)
        setIconContactInscrip(iconoContactInscrip)
        setColorContact("text-gray-dark")
        setIconMasiveContact(iconoMasiveA)
        setColorMasive("text-green")
      }
      else{
        setColor("text-gray-dark")
        setColorContact("text-gray-dark")
        setColorMasive("text-gray-dark")
        setIconInscrip(iconoInscrip)
        setIconContactInscrip(iconoContactInscrip)
        setIconMasiveContact(iconoContactInscrip)
      }
      setTabs(index);
    };

    
    

    render() {
      return (
        <>
          <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={cancelationModal}
            toggle={() => setCancelationModal(!cancelationModal)}
          >
            <div className="p-4">
            <div onClick={ejecutasalir} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                                    <h1 style={{margin:"-15px -10px 0px 0px",fontSize:"20px"}}>
                                        <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
                                          <img
                                            className=""
                                            src={
                                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo.png").default
                                            }/>
                                            </span></h1>
                                </div>
              <div class="my-modal-header">
                <img
                  alt="delete-icon"
                  class="my-header-image"
                  src={
                    require("../../assets/img/illustrations/cancel.svg").default
                  }
                />
                <div class="header-title">
                  <h5 class="avv-title-bold">
                    ¿Quieres salir de la transacción?
                  </h5>
                  <p class="header-subtitle">
                    La información que has ingresado hasta el momento se
                    borrará.
                  </p>
                </div>
              </div>
              <div class="my-modal-footer pt-2">
                <button
                  class="btn bg-white text-green shadow"
                  type="button"
                  onClick={() => setCancelationModal(false)}
                >
                  {" "}
                  No, volver{" "}
                </button>
                <button
                  class="my-btn btn bg-green text-white shadow"
                  type="button"
                  onClick={() => {
                    setTabs(tabToGo);
                    setCancelationModal(false);
                    setStep(0);
                    setTabToGo(0);
                  }}
                >
                  {" "}
                  SÍ, SALIR{" "}
                </button>
              </div>
            </div>
          </Modal>
          <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={resultModal}
            toggle={() => setResultModal(!cancelationModal)}
          >
            <div className="p-4">
              <div class="my-modal-header">
                <img
                  alt="delete-icon"
                  class="my-header-image"
                  style={{width:"100px", height:"100px"}}
                  src={
                    require("../../assets/img/illustrations/add-contact-success.svg")
                      .default
                  }
                />
                <div class="header-title">
                  <h5 class="avv-title-bold">Contacto creado exitosamente</h5>
                  <p class="header-subtitle">
                      El contacto fue creado con éxito, si es un contacto externo debes esperar 24 horas para que se valide la información enviada.
                  </p>
                </div>
              </div>
              <div class="my-modal-footer pt-2">
                <button
                  class="my-btn btn bg-green text-white shadow"
                  type="button"
                  onClick={() => {
                    setTabs(tabToGo);
                    setResultModal(false);
                    setStep(0);
                    setTabToGo(0);
                  }}
                >
                  Continuar
                </button>
              </div>
            </div>
          </Modal>
          <div className="header pb-4 pt-5 pt-md-8">
            <Container fluid>
              <div className="header-body">
                <Nav
                  className="justify-content-center flex-column flex-md-row"
                  id="tabs-icons-text"
                  pills
                  role="tablist"
                >
                  <NavItem>
                    <NavLink
                      aria-selected={tabs === 1}
                      className={classnames(
                        "card-body ml-2 mb-2 mb-xl-0 shadow",
                        {
                          active:activeInsCont,
                        }
                      )}
                      onClick={(e) => {
                        if (step > 0) {
                          setTabToGo(1);
                          setCancelationModal(true);
                        } else {
                          this.toggleNavs(e, "tabs", 1);
                        }
                      }}
                      href="#add-contact"
                      role="tab"
                    >
                      <Row className="justify-content-center "style={{"padding":0.5 +"rem",height:40 + "px"}}>
                        <div className="icon icon-shape mt-0 mb-0 pb-0"style={{"padding":0 +"rem"}}>
                          <img
                            className="my-header-image mt-0 mb-4 pt-0"
                            src={iconInscrip}
                          />
                        </div>
                      </Row>
                      <Row className={classnames ("justify-content-center mt-0 pb-0",
                            color)}>
                        <p
                          className="mt-1 mb-0 pt-0 text-bold"
                          style={{
                            fontSize: 14 + "px",
                            width: 105 + "px",
                            textAlign: "center",
                            lineHeight: 1.25 + 'em',
                            marginTop:2 +"px"
                          }}
                        >
                          Inscribir Contacto
                        </p>
                      </Row>
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      aria-selected={tabs === 2}
                      className={classnames(
                        "card-body ml-2 mb-2 mb-xl-0 shadow",
                        {
                          active:activeContInscritos,
                        }
                      )}
                      onClick={(e) => {
                        if (step > 0) {
                          setTabToGo(2);
                          setActiveInsCont(false)
                          setActiveContInscritos(true)
                          dispatch(cambiaruta("Inicio/Contactos/Contactos Inscritos"))
                          setColor("text-gray-dark")
                          setIconInscrip(iconoInscrip)
                          setIconContactInscrip(iconoContactInscripA)
                          setColorContact("text-green")
                          setIconMasiveContact(iconoMasive)
                          setColorMasive("text-gray-dark")
                          setCancelationModal(true);
                        } else {
                          this.toggleNavs(e, "tabs", 2);
                        }
                        GetRelatedAccount();
                      }}
                      href="#view-contacts"
                      role="tab"
                    >
                      <Row className="justify-content-center"style={{"padding":0.5 +"rem",height:40 + "px"}}>
                        <div className="icon icon-shape mt-0 mb-0 pb-0"style={{"padding":0 +"rem"}}>
                          <img
                            className="my-header-image mt-0 mb-4 pt-0"
                            src={iconContactInscrip}
                          />
                        </div>
                      </Row>
                      <Row className={classnames ("justify-content-center mt-0 pb-0",
                            colorContact)}>
                        <p
                          className="mt-1 mb-0 pt-0 text-bold"
                          style={{
                            fontSize: 14 + "px",
                            width: 105 + "px",
                            textAlign: "center",
                            lineHeight: 1.25 + 'em',
                            marginTop:2 +"px"
                          }}
                        >
                          Contactos Inscritos
                        </p>
                      </Row>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      aria-selected={tabs === 3}
                      className={classnames(
                        "card-body ml-2 mb-2 mb-xl-0 shadow",
                        {
                          active: tabs === 3,
                        }
                      )}
                      onClick={(e) => {
                        if (step > 0) {
                          setTabToGo(3);
                          setActiveInsCont(false)
                          setActiveContInscritos(false)
                          dispatch(cambiaruta("Inicio/Contactos/Cargues Masivos"))
                          setColor("text-gray-dark")
                          setIconInscrip(iconoInscrip)
                          setIconContactInscrip(iconoContactInscrip)
                          setColorContact("text-gray-dark")
                          setIconMasiveContact(iconoMasiveA)
                          setColorMasive("text-green")
                          setCancelationModal(true);
                        } else {
                          this.toggleNavs(e, "tabs", 3);
                        }
                        //GetRelatedAccount();
                      }}
                      href="#view-contacts"
                      role="tab"
                    >
                      <Row className="justify-content-center"style={{"padding":0.5 +"rem",height:40 + "px"}}>
                        <div className="icon icon-shape mt-0 mb-0 pb-0"style={{"padding":0 +"rem"}}>
                          <img
                            className="my-header-image mt-0 mb-4 pt-0"
                            src={iconMasiveContact}
                          />
                        </div>
                      </Row>
                      <Row className={classnames ("justify-content-center mt-0 pb-0",
                            colorMasive)}>
                        <p
                          className="mt-1 mb-0 pt-0 text-bold"
                          style={{
                            fontSize: 14 + "px",
                            width: 105 + "px",
                            textAlign: "center",
                            lineHeight: 1.25 + 'em',
                            marginTop:2 +"px"
                          }}
                        >
                          Cargues &nbsp;Masivos
                        </p>
                      </Row>
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </Container>
          </div>
          <Container className="mb-4" key="container">
            <TabContent activeTab={"tabs" + tabs} key="tab-active">
              <TabPane tabId="tabs0">
                <Container fluid>
                  <div className="text-center m-4">
                    <h2 class="ml-2"> ¿En que consiste Contactos? </h2>
                  </div>
                  <Row className="mt-5 ml-7 mr-7">
                    <Col xl="6" lg="6">
                      <div class="feature ng-star-inserted">
                        <div class="icon">
                          <span class="icon icon-usuario">
                            <i class="fas fa-user"></i>
                          </span>
                        </div>
                        <div class="description">
                          <p>
                            <span class="avv-title-semibold">
                              Inscribe tus Contactos
                            </span>{" "}
                            de las personas a las cuales haces transferencias.
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col xl="6" lg="6">
                      <div class="feature ng-star-inserted">
                        <div class="icon">
                          <span class="icon icon-usuario">
                            <i class="fas fa-list-ol"></i>
                          </span>
                        </div>
                        <div class="description">
                          <p>
                            <span class="avv-title-semibold">
                              Listado de Contactos Inscritos
                            </span>{" "}
                            para consultar, editar o borrar de acuerdo a lo que
                            necesites.
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col xl="6" lg="6">
                      <div class="feature ng-star-inserted">
                        <div class="icon">
                          <span class="icon icon-usuario">
                            <i class="fas fa-list-ol"></i>
                          </span>
                        </div>
                        <div class="description">
                          <p>
                            <span class="avv-title-semibold">
                              Cargue masivo de contactos
                            </span>{" "}
                            para hacer cargues de contactos, o cambiar el estado.
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </TabPane>
              <TabPane tabId="tabs1" className="">
                <Container fluid>
                  <Row>
                    <Col xl="3" lg="2"></Col>
                    <Col xl="6" lg="8">
                      <DivStepper step={step} listStep={listStep} tab={1}>
                        <DivStep>
                          <div className="text-center m-4">
                            <h2 class="ml-2">
                              {" "}
                              Ingresa los datos de tu Contacto{" "}
                            </h2>
                          </div>
                          <form onSubmit={handleSubmit} >
                          <InputGroup className="input-group-alternative mt-2 mb-3">
                                  <div className="inputs-icons-borderbott">
                                    <select
                                      onChange={getTypeDocument}
                                      placeholder="Selecciona el tipo de documento"
                                      style={{border:"none",width:"100%",fontSize:"14px",height:"33px"}}
                                    >
                                      <option value="1" selected={tidelec[0]}>Cédula de Ciudadanía</option>
                                      <option value="2" selected={tidelec[1]}>Tarjeta de Identidad</option>
                                      <option value="3" selected={tidelec[2]}>NIT</option>
                                      <option value="5" selected={tidelec[3]}>Pasaporte</option>
                                      <option value="6" selected={tidelec[4]}>Carnet Diplomático</option>
                                      <option value="8" selected={tidelec[5]}>Fideicomiso</option>
                                      <option value="9" selected={tidelec[6]}>Registro Civil de Nacimiento</option>
                                    </select>
                                    <img style={{height:"12px", }} src={IconTid}></img>
                                  </div>
                                </InputGroup>
                          <InputGroup className="input-group-alternative mt-2 mb-3">
                
                            <div className="inputs-icons-borderbott">
                              <Input
                                required
                                maxLength={17}
                                placeholder="Documento de Identidad"
                                pattern = "[A-Za-z0-9]+"
                                type="text"
                                //ref={refNid}
                                onChange={NIDChange}
                                //value={infContModif.id}
                                style={{fontSize:"14px",border:"none", width:"250px",height:"33px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                              />
                              <i className="fas fa-id-card" />
                            </div>
                          </InputGroup>
                          <InputGroup className="input-group-alternative mb-4">
                            
                                
                            <div className="inputs-icons-borderbott">
                              <Input
                                required
                                maxLength={50}
                                pattern="[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]+"
                                placeholder="Nombre"
                                type="text"
                                onChange={NameChange}
                                //value={infContModif.name}
                                style={{fontSize:"14px",border:"none", width:"250px",height:"33px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                              />
                              <i className="fas fa-id-card" />
                            </div>  
                            
                          </InputGroup>
                          <button
                            type="submit"
                            //onClick={() => BuildContact()}
                            className="my-btn bg-green text-white btn shadow btn-rounded btn-block btn-lg mr-auto ml-auto"
                            style={{width:"50%"}}
                          >
                            Continuar
                          </button>
                        </form>
                        </DivStep>
                        <DivStep>

                        <form onSubmit={handleSubmit2}>
                          <div className="text-center m-2">
                            <h2 class="ml-2">
                              {" "}
                              Ingresa los datos de la Cuenta{" "}
                            </h2>
                          </div>
                          <Row>
                            <div
                              className={classnames(
                                "radius-left shadow p-3 mt-4 mb-4 ml-6 text-center text-green cursor-pointer col",
                                {
                                  active: types === "1",
                                }
                              )}
                              onClick={() => getTypeAccount("1")}
                            >
                              Cuenta de Ahorros
                            </div>
                            <div
                              className={classnames(
                                "radius-right shadow p-3 mt-4 mb-4 mr-6 mr-4 text-center text-green cursor-pointer col",
                                {
                                  active: types === "3",
                                }
                              )}
                              onClick={() => getTypeAccount("3")}
                            >
                              Cuenta Corriente
                            </div>
                          </Row>
                          <InputGroup
                            className="input-group-alternative mt-3 mb-3"
                            key="group-accountNumber"
                          >
                            <div className="inputs-icons-borderbott">
                              <Input
                                required
                                maxLength={19}
                                placeholder="Número de Cuenta"
                                type="text"
                                onChange={AccountNumberChange}
                                style={{fontSize:"14px",border:"none", width:"250px",height:"33px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                              />
                              <i className="far fa-credit-card" />
                            </div>  
                          </InputGroup>
                          <InputGroup className="input-group-alternative mt-3 mb-3">
                            <div className="inputs-icons-borderbott">
                              <select
                                required
                                onChange={BankChange}
                                class="selectpicker"
                                placeholder="Tipo de Documento"
                                //className="form-control input-group-alternative"
                                style={{fontSize:"14px",border:"none", width:"100%",height:"33px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                                
                              >
                              <option value="">Escoja un banco</option>
                              {baseBanco?.banco?.map((bancos) => {

                                return <option key={bancos.id} value={bancos.id} >{bancos.value}</option>
                                  })}
                                
                                {/* <option value="">Escoja un banco</option>
                                <option value="1_BANCO DE BOGOTA">BANCO DE BOGOTA</option>
                                <option value="2_BANCO POPULAR">BANCO POPULAR</option>
                                <option value="6_ITAU CORPBANCA COLOMBIA S.A.">
                                  ITAU CORPBANCA COLOMBIA S.A.
                                </option>
                                <option value="7_BANCOLOMBIA S.A.">BANCOLOMBIA S.A.</option>
                                <option value="9_CITIBANK COLOMBIA">CITIBANK COLOMBIA</option>
                                <option value="12_GNB SUDAMERIS S.A.">GNB SUDAMERIS S.A.</option>
                                <option value="13_BBVA COLOMBIA">BBVA COLOMBIA</option>
                                <option value="19_COLPATRIA">COLPATRIA</option>
                                <option value="23_BANCO DE OCCIDENTE">BANCO DE OCCIDENTE</option>
                                <option value="32_BANCO CAJA SOCIAL - BCSC S.A.">
                                  BANCO CAJA SOCIAL - BCSC S.A.
                                </option>
                                <option value="40_BANCO AGRARIO DE COLOMBIA S.A.">
                                  BANCO AGRARIO DE COLOMBIA S.A.
                                </option>
                                <option value="51_BANCO DAVIVIENDA S.A.">BANCO DAVIVIENDA S.A.</option>
                                <option value="52_BANCO AV VILLAS">BANCO AV VILLAS</option>
                                <option value="53_BANCO W S.A.">BANCO W S.A.</option>
                                <option value="58_BANCO CREDIFINANCIERA S.A.C.F">
                                  BANCO CREDIFINANCIERA S.A.C.F
                                </option>
                                <option value="59_BANCAMIA">BANCAMIA</option>
                                <option value="60_BANCO PICHINCHA S.A.">BANCO PICHINCHA S.A.</option>
                                <option value="61_BANCOOMEVA">BANCOOMEVA</option>
                                <option value="62_CMR FALABELLA S.A.">CMR FALABELLA S.A.</option>
                                <option value="63_BANCO FINANDINA S.A.">BANCO FINANDINA S.A.</option>
                                <option value="65_BANCO SANTANDER DE NEGOCIOS COLOMBIA S.A.">
                                  BANCO SANTANDER DE NEGOCIOS COLOMBIA S.A.
                                </option>
                                <option value="66_BANCO COOPERATIVO COOPCENTRAL">
                                  BANCO COOPERATIVO COOPCENTRAL
                                </option>
                                <option value="67_BANCO COMPARTIR S.A.">BANCO COMPARTIR S.A.</option>
                                <option value="69_BANCO SERFINANZA S.A.">BANCO SERFINANZA S.A.</option> */}
                              </select>
                              
                              
                              <i className="far fa-list-alt" />
                            </div>
                            
                          </InputGroup>
                          <InputGroup className="input-group-alternative mt-3 mb-3">
                   
                            <div className="inputs-icons-borderbott"
                            >
                              <select
                                required
                                onChange={CityChange}
                                class="selectpicker"
                                placeholder="Tipo de Documento"
                                //className="form-control input-group-alternative"
                                style={{fontSize:"14px",border:"none", width:"100%",height:"33px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                              >
                                <option value="">Ciudad</option>
                                <option value="5001_MEDELLIN">MEDELLIN - ANTIOQUIA</option>
                                <option value="5002_ABEJORRAL">ABEJORRAL - ANTIOQUIA</option>
                                <option value="5004_ABRIAQUI">ABRIAQUI - ANTIOQUIA</option>
                                <option value="5021_ALEJANDRIA">ALEJANDRIA - ANTIOQUIA</option>
                                <option value="5030_AMAGA">AMAGA - ANTIOQUIA</option>
                                <option value="5031_AMALFI">AMALFI - ANTIOQUIA</option>
                                <option value="5034_ANDES">ANDES - ANTIOQUIA</option>
                                <option value="5036_ANGELOPOLIS">ANGELOPOLIS - ANTIOQUIA</option>
                                <option value="5038_ANGOSTURA">ANGOSTURA - ANTIOQUIA</option>
                                <option value="5040_ANORI">ANORI - ANTIOQUIA</option>
                                <option value="5042_SANTA FE DE ANTIOQUIA">SANTA FE DE ANTIOQUIA - ANTIOQUIA</option>
                                <option value="5044_ANZA">ANZA - ANTIOQUIA</option>
                                <option value="5045_APARTADO">APARTADO - ANTIOQUIA</option>
                                <option value="5051_ARBOLETES">ARBOLETES - ANTIOQUIA</option>
                                <option value="5055_ARGELIA">ARGELIA - ANTIOQUIA</option>
                                <option value="5059_ARMENIA">ARMENIA - ANTIOQUIA</option>
                                <option value="5079_BARBOSA">BARBOSA - ANTIOQUIA</option>
                                <option value="5086_BELMIRA">BELMIRA - ANTIOQUIA</option>
                                <option value="5088_BELLO">BELLO - ANTIOQUIA</option>
                                <option value="5091_BETANIA">BETANIA - ANTIOQUIA</option>
                                <option value="5093_BETULIA">BETULIA - ANTIOQUIA</option>
                                <option value="5101_BOLIVAR">BOLIVAR - ANTIOQUIA</option>
                                <option value="5107_BRICENO">BRICENO - ANTIOQUIA</option>
                                <option value="5113_BURITICA">BURITICA - ANTIOQUIA</option>
                                <option value="5120_CACERES">CACERES - ANTIOQUIA</option>
                                <option value="5125_CAICEDO">CAICEDO - ANTIOQUIA</option>
                                <option value="5129_CALDAS">CALDAS - ANTIOQUIA</option>
                                <option value="5134_CAMPAMENTO">CAMPAMENTO - ANTIOQUIA</option>
                                <option value="5138_CAÑASGORDAS">CAÑASGORDAS - ANTIOQUIA</option>
                                <option value="5142_CARACOLI">CARACOLI - ANTIOQUIA</option>
                                <option value="5145_CARAMANTA">CARAMANTA - ANTIOQUIA</option>
                                <option value="5147_CAREPA">CAREPA - ANTIOQUIA</option>
                                <option value="5148_CARMEN DE VIBORAL">CARMEN DE VIBORAL - ANTIOQUIA</option>
                                <option value="5150_CAROLINA">CAROLINA - ANTIOQUIA</option>
                                <option value="5154_CAUCASIA">CAUCASIA - ANTIOQUIA</option>
                                <option value="5172_CHIGORODO">CHIGORODO - ANTIOQUIA</option>
                                <option value="5190_CISNEROS">CISNEROS - ANTIOQUIA</option>
                                <option value="5197_COCORNA">COCORNA - ANTIOQUIA</option>
                                <option value="5206_CONCEPCION">CONCEPCION - ANTIOQUIA</option>
                                <option value="5209_CONCORDIA">CONCORDIA - ANTIOQUIA</option>
                                <option value="5212_COPACABANA">COPACABANA - ANTIOQUIA</option>
                                <option value="5234_DABEIBA">DABEIBA - ANTIOQUIA</option>
                                <option value="5237_DON MATIAS">DON MATIAS - ANTIOQUIA</option>
                                <option value="5240_EBEJICO">EBEJICO - ANTIOQUIA</option>
                                <option value="5250_EL BAGRE">EL BAGRE - ANTIOQUIA</option>
                                <option value="5264_ENTRERRIOS">ENTRERRIOS - ANTIOQUIA</option>
                                <option value="5266_ENVIGADO">ENVIGADO - ANTIOQUIA</option>
                                <option value="5282_FREDONIA">FREDONIA - ANTIOQUIA</option>
                                <option value="5284_FRONTINO">FRONTINO - ANTIOQUIA</option>
                                <option value="5306_GIRALDO">GIRALDO - ANTIOQUIA</option>
                                <option value="5308_GIRARDOTA">GIRARDOTA - ANTIOQUIA</option>
                                <option value="5310_GOMEZ PLATA">GOMEZ PLATA - ANTIOQUIA</option>
                                <option value="5313_GRANADA">GRANADA - ANTIOQUIA</option>
                                <option value="5315_GUADALUPE">GUADALUPE - ANTIOQUIA</option>
                                <option value="5318_GUARNE">GUARNE - ANTIOQUIA</option>
                                <option value="5321_GUATAPE">GUATAPE - ANTIOQUIA</option>
                                <option value="5347_HELICONIA">HELICONIA - ANTIOQUIA</option>
                                <option value="5353_HISPANIA">HISPANIA - ANTIOQUIA</option>
                                <option value="5360_ITAGUI">ITAGUI - ANTIOQUIA</option>
                                <option value="5361_ITUANGO">ITUANGO - ANTIOQUIA</option>
                                <option value="5364_JARDIN">JARDIN - ANTIOQUIA</option>
                                <option value="5368_JERICO">JERICO - ANTIOQUIA</option>
                                <option value="5376_LA CEJA">LA CEJA - ANTIOQUIA</option>
                                <option value="5380_LA ESTRELLA">LA ESTRELLA - ANTIOQUIA</option>
                                <option value="5390_LA PINTADA">LA PINTADA - ANTIOQUIA</option>
                                <option value="5400_LA UNION">LA UNION - ANTIOQUIA</option>
                                <option value="5411_LIBORINA">LIBORINA - ANTIOQUIA</option>
                                <option value="5425_MACEO">MACEO - ANTIOQUIA</option>
                                <option value="5440_MARINILLA">MARINILLA - ANTIOQUIA</option>
                                <option value="5467_MONTEBELLO">MONTEBELLO - ANTIOQUIA</option>
                                <option value="5475_MURINDO">MURINDO - ANTIOQUIA</option>
                                <option value="5480_MUTATA">MUTATA - ANTIOQUIA</option>
                                <option value="5483_NARINO">NARINO - ANTIOQUIA</option>
                                <option value="5490_NECOCLI">NECOCLI - ANTIOQUIA</option>
                                <option value="5495_NECHI">NECHI - ANTIOQUIA</option>
                                <option value="5501_OLAYA">OLAYA - ANTIOQUIA</option>
                                <option value="5541_PENOL">PENOL - ANTIOQUIA</option>
                                <option value="5543_PEQUE">PEQUE - ANTIOQUIA</option>
                                <option value="5576_PUEBLORRICO">PUEBLORRICO - ANTIOQUIA</option>
                                <option value="5579_PUERTO BERRIO">PUERTO BERRIO - ANTIOQUIA</option>
                                <option value="5585_PTO NARE">PTO NARE(LAMAGDALENA) - ANTIOQUIA</option>
                                <option value="5591_PUERTO TRIUNFO">PUERTO TRIUNFO - ANTIOQUIA</option>
                                <option value="5604_REMEDIOS">REMEDIOS - ANTIOQUIA</option>
                                <option value="5607_RETIRO">RETIRO - ANTIOQUIA</option>
                                <option value="5615_RIONEGRO">RIONEGRO - ANTIOQUIA</option>
                                <option value="5628_SABANALARGA">SABANALARGA - ANTIOQUIA</option>
                                <option value="5631_SABANETA">SABANETA - ANTIOQUIA</option>
                                <option value="5642_SALGAR">SALGAR - ANTIOQUIA</option>
                                <option value="5647_SAN ANDRES">SAN ANDRES - ANTIOQUIA</option>
                                <option value="5649_SAN CARLOS">SAN CARLOS - ANTIOQUIA</option>
                                <option value="5652_SAN FRANCISCO">SAN FRANCISCO - ANTIOQUIA</option>
                                <option value="5656_SAN JERONIMO">SAN JERONIMO - ANTIOQUIA</option>
                                <option value="5658_SAN JOSE DE LA MONTANA">SAN JOSE DE LA MONTANA - ANTIOQUIA</option>
                                <option value="5659_SAN JUAN DE URABA">SAN JUAN DE URABA - ANTIOQUIA</option>
                                <option value="5660_SAN LUIS">SAN LUIS - ANTIOQUIA</option>
                                <option value="5664_SAN PEDRO">SAN PEDRO - ANTIOQUIA</option>
                                <option value="5665_SAN PEDRO DE URABA">SAN PEDRO DE URABA - ANTIOQUIA</option>
                                <option value="5667_SAN RAFAEL">SAN RAFAEL - ANTIOQUIA</option>
                                <option value="5670_SAN ROQUE">SAN ROQUE - ANTIOQUIA</option>
                                <option value="5674_SAN VICENTE">SAN VICENTE - ANTIOQUIA</option>
                                <option value="5679_SANTA BARBARA">SANTA BARBARA - ANTIOQUIA</option>
                                <option value="5686_SANTA ROSA DE OSOS">SANTA ROSA DE OSOS - ANTIOQUIA</option>
                                <option value="5690_SANTO DOMINGO">SANTO DOMINGO - ANTIOQUIA</option>
                                <option value="5697_SANTUARIO">SANTUARIO - ANTIOQUIA</option>
                                <option value="5736_SEGOVIA">SEGOVIA - ANTIOQUIA</option>
                                <option value="5756_SONSON">SONSON - ANTIOQUIA</option>
                                <option value="5761_SOPETRAN">SOPETRAN - ANTIOQUIA</option>
                                <option value="5789_TAMESIS">TAMESIS - ANTIOQUIA</option>
                                <option value="5790_TARAZA">TARAZA - ANTIOQUIA</option>
                                <option value="5792_TARSO">TARSO - ANTIOQUIA</option>
                                <option value="5809_TITIRIBI">TITIRIBI - ANTIOQUIA</option>
                                <option value="5819_TOLEDO">TOLEDO - ANTIOQUIA</option>
                                <option value="5837_TURBO">TURBO - ANTIOQUIA</option>
                                <option value="5842_URAMITA">URAMITA - ANTIOQUIA</option>
                                <option value="5847_URRAO">URRAO - ANTIOQUIA</option>
                                <option value="5854_VALDIVIA">VALDIVIA - ANTIOQUIA</option>
                                <option value="5856_VALPARAISO">VALPARAISO - ANTIOQUIA</option>
                                <option value="5858_VEGACHI">VEGACHI - ANTIOQUIA</option>
                                <option value="5861_VENECIA">VENECIA - ANTIOQUIA</option>
                                <option value="5873_VIGIA DEL FUERTE">VIGIA DEL FUERTE - ANTIOQUIA</option>
                                <option value="5885_YALI">YALI - ANTIOQUIA</option>
                                <option value="5887_YARUMAL">YARUMAL - ANTIOQUIA</option>
                                <option value="5890_YOLOMBO">YOLOMBO - ANTIOQUIA</option>
                                <option value="5893_YONDO">YONDO - ANTIOQUIA</option>
                                <option value="5895_ZARAGOZA">ZARAGOZA - ANTIOQUIA</option>
                                <option value="5991_ALTAMIRA">ALTAMIRA - ANTIOQUIA</option>
                                <option value="5992_SAN CRISTOBAL">SAN CRISTOBAL - ANTIOQUIA</option>
                                <option value="8001_BARRANQUILLA">BARRANQUILLA - ATLANTICO</option>
                                <option value="8078_BARANOA">BARANOA - ATLANTICO</option>
                                <option value="8137_CAMPO DE LA CRUZ">CAMPO DE LA CRUZ - ATLANTICO</option>
                                <option value="8141_CANDELARIA">CANDELARIA - ATLANTICO</option>
                                <option value="8296_GALAPA">GALAPA - ATLANTICO</option>
                                <option value="8372_JUAN DE ACOSTA">JUAN DE ACOSTA - ATLANTICO</option>
                                <option value="8421_LURUACO">LURUACO - ATLANTICO</option>
                                <option value="8433_MALAMBO">MALAMBO - ATLANTICO</option>
                                <option value="8436_MANATI">MANATI - ATLANTICO</option>
                                <option value="8520_PALMAR DE VARELA">PALMAR DE VARELA - ATLANTICO</option>
                                <option value="8549_PIOJO">PIOJO - ATLANTICO</option>
                                <option value="8558_POLONUEVO">POLONUEVO - ATLANTICO</option>
                                <option value="8560_PONEDERA">PONEDERA - ATLANTICO</option>
                                <option value="8573_PUERTO COLOMBIA">PUERTO COLOMBIA - ATLANTICO</option>
                                <option value="8606_REPELON">REPELON - ATLANTICO</option>
                                <option value="8634_SABANAGRANDE">SABANAGRANDE - ATLANTICO</option>
                                <option value="8638_SABANALARGA">SABANALARGA - ATLANTICO</option>
                                <option value="8675_SANTA LUCIA">SANTA LUCIA - ATLANTICO</option>
                                <option value="8685_SANTO TOMAS">SANTO TOMAS - ATLANTICO</option>
                                <option value="8758_SOLEDAD">SOLEDAD - ATLANTICO</option>
                                <option value="8770_SUAN">SUAN - ATLANTICO</option>
                                <option value="8832_TUBARA">TUBARA - ATLANTICO</option>
                                <option value="8849_USIACURI">USIACURI - ATLANTICO</option>
                                <option value="11001_BOGOTA D.C">BOGOTA D.C - BOGOTA D.C</option>
                                <option value="13001_CARTAGENA">CARTAGENA - BOLIVAR</option>
                                <option value="13006_ACHI">ACHI - BOLIVAR</option>
                                <option value="13030_ALTOS DEL ROSARIO">ALTOS DEL ROSARIO - BOLIVAR</option>
                                <option value="13042_ARENAL">ARENAL - BOLIVAR</option>
                                <option value="13052_ARJONA">ARJONA - BOLIVAR</option>
                                <option value="13062_ARROYOHONDO">ARROYOHONDO - BOLIVAR</option>
                                <option value="13074_BARRANCO DE LOBA">BARRANCO DE LOBA - BOLIVAR</option>
                                <option value="13140_CALAMAR">CALAMAR - BOLIVAR</option>
                                <option value="13160_CANTAGALLO">CANTAGALLO - BOLIVAR</option>
                                <option value="13188_CICUCO">CICUCO - BOLIVAR</option>
                                <option value="13212_CORDOBA">CORDOBA - BOLIVAR</option>
                                <option value="13222_CLEMENCIA">CLEMENCIA - BOLIVAR</option>
                                <option value="13244_EL CARMEN DE BOLIVAR">EL CARMEN DE BOLIVAR - BOLIVAR</option>
                                <option value="13248_EL GUAMO">EL GUAMO - BOLIVAR</option>
                                <option value="13268_EL PENON">EL PENON - BOLIVAR</option>
                                <option value="13300_HATILLO DE LOBA">HATILLO DE LOBA - BOLIVAR</option>
                                <option value="13430_MAGANGUE">MAGANGUE - BOLIVAR</option>
                                <option value="13433_MAHATES">MAHATES - BOLIVAR</option>
                                <option value="13440_MARGARITA">MARGARITA - BOLIVAR</option>
                                <option value="13442_MARIA LA BAJA">MARIA LA BAJA - BOLIVAR</option>
                                <option value="13458_MONTECRISTO">MONTECRISTO - BOLIVAR</option>
                                <option value="13468_MOMPOS">MOMPOS - BOLIVAR</option>
                                <option value="13473_MORALES">MORALES - BOLIVAR</option>
                                <option value="13549_PINILLOS">PINILLOS - BOLIVAR</option>
                                <option value="13580_REGIDOR">REGIDOR - BOLIVAR</option>
                                <option value="13600_RIO VIEJO">RIO VIEJO - BOLIVAR</option>
                                <option value="13620_SAN CRISTOBAL">SAN CRISTOBAL - BOLIVAR</option>
                                <option value="13647_SAN ESTANISLAO">SAN ESTANISLAO - BOLIVAR</option>
                                <option value="13650_SAN FERNANDO">SAN FERNANDO - BOLIVAR</option>
                                <option value="13654_SAN JACINTO">SAN JACINTO - BOLIVAR</option>
                                <option value="13655_SAN JACINTO DEL CAUCA">SAN JACINTO DEL CAUCA - BOLIVAR</option>
                                <option value="13657_SAN JUAN NEPOMUCENO">SAN JUAN NEPOMUCENO - BOLIVAR</option>
                                <option value="13667_SAN MARTIN DE LOBA">SAN MARTIN DE LOBA - BOLIVAR</option>
                                <option value="13670_SAN PABLO">SAN PABLO - BOLIVAR</option>
                                <option value="13673_SANTA CATALINA">SANTA CATALINA - BOLIVAR</option>
                                <option value="13683_SANTA ROSA">SANTA ROSA - BOLIVAR</option>
                                <option value="13688_SANTA ROSA DEL SUR">SANTA ROSA DEL SUR - BOLIVAR</option>
                                <option value="13744_SIMITI">SIMITI - BOLIVAR</option>
                                <option value="13760_SOPLAVIENTO">SOPLAVIENTO - BOLIVAR</option>
                                <option value="13780_TALAIGUA NUEVO">TALAIGUA NUEVO - BOLIVAR</option>
                                <option value="13810_TIQUISIO">TIQUISIO - BOLIVAR</option>
                                <option value="13836_TURBACO">TURBACO - BOLIVAR</option>
                                <option value="13838_TURBANA">TURBANA - BOLIVAR</option>
                                <option value="13873_VILLANUEVA">VILLANUEVA - BOLIVAR</option>
                                <option value="13894_ZAMBRANO">ZAMBRANO - BOLIVAR</option>
                                <option value="15001_TUNJA">TUNJA - BOYACA</option>
                                <option value="15022_ALMEIDA">ALMEIDA - BOYACA</option>
                                <option value="15047_AQUITANIA">AQUITANIA - BOYACA</option>
                                <option value="15051_ARCABUCO">ARCABUCO - BOYACA</option>
                                <option value="15087_BELEN">BELEN - BOYACA</option>
                                <option value="15090_BERBEO">BERBEO - BOYACA</option>
                                <option value="15092_BETEITIVA">BETEITIVA - BOYACA</option>
                                <option value="15097_BOAVITA">BOAVITA - BOYACA</option>
                                <option value="15104_BOYACA">BOYACA - BOYACA</option>
                                <option value="15106_BRICENO">BRICENO - BOYACA</option>
                                <option value="15109_BUENAVISTA">BUENAVISTA - BOYACA</option>
                                <option value="15114_BUSBANZA">BUSBANZA - BOYACA</option>
                                <option value="15131_CALDAS">CALDAS - BOYACA</option>
                                <option value="15135_CAMPOHERMOSO">CAMPOHERMOSO - BOYACA</option>
                                <option value="15162_CERINZA">CERINZA - BOYACA</option>
                                <option value="15172_CHINAVITA">CHINAVITA - BOYACA</option>
                                <option value="15176_CHIQUINQUIRA">CHIQUINQUIRA - BOYACA</option>
                                <option value="15180_CHISCAS">CHISCAS - BOYACA</option>
                                <option value="15183_CHITA">CHITA - BOYACA</option>
                                <option value="15185_CHITARAQUE">CHITARAQUE - BOYACA</option>
                                <option value="15187_CHIVATA">CHIVATA - BOYACA</option>
                                <option value="15189_CIENEGA">CIENEGA - BOYACA</option>
                                <option value="15204_COMBITA">COMBITA - BOYACA</option>
                                <option value="15212_COPER">COPER - BOYACA</option>
                                <option value="15215_CORRALES">CORRALES - BOYACA</option>
                                <option value="15218_COVARACHIA">COVARACHIA - BOYACA</option>
                                <option value="15223_CUBARA">CUBARA - BOYACA</option>
                                <option value="15224_CUCAITA">CUCAITA - BOYACA</option>
                                <option value="15226_CUITIVA">CUITIVA - BOYACA</option>
                                <option value="15232_CHIQUIZA">CHIQUIZA - BOYACA</option>
                                <option value="15236_CHIVOR">CHIVOR - BOYACA</option>
                                <option value="15238_DUITAMA">DUITAMA - BOYACA</option>
                                <option value="15244_EL COCUY">EL COCUY - BOYACA</option>
                                <option value="15248_EL ESPINO">EL ESPINO - BOYACA</option>
                                <option value="15272_FIRAVITOBA">FIRAVITOBA - BOYACA</option>
                                <option value="15276_FLORESTA">FLORESTA - BOYACA</option>
                                <option value="15293_GACHANTIVA">GACHANTIVA - BOYACA</option>
                                <option value="15296_GAMEZA">GAMEZA - BOYACA</option>
                                <option value="15299_GARAGOA">GARAGOA - BOYACA</option>
                                <option value="15317_GUACAMAYAS">GUACAMAYAS - BOYACA</option>
                                <option value="15322_GUATEQUE">GUATEQUE - BOYACA</option>
                                <option value="15325_GUAYATA">GUAYATA - BOYACA</option>
                                <option value="15332_GUICAN">GUICAN - BOYACA</option>
                                <option value="15362_IZA">IZA - BOYACA</option>
                                <option value="15367_JENESANO">JENESANO - BOYACA</option>
                                <option value="15377_LABRANZAGRANDE">LABRANZAGRANDE - BOYACA</option>
                                <option value="15380_LA CAPILLA">LA CAPILLA - BOYACA</option>
                                <option value="15401_LA VICTORIA">LA VICTORIA - BOYACA</option>
                                <option value="15403_LA UVITA">LA UVITA - BOYACA</option>
                                <option value="15407_VILLA DE LEYVA">VILLA DE LEYVA - BOYACA</option>
                                <option value="15425_MACANAL">MACANAL - BOYACA</option>
                                <option value="15442_MARIPI">MARIPI - BOYACA</option>
                                <option value="15455_MIRAFLORES">MIRAFLORES - BOYACA</option>
                                <option value="15464_MONGUA">MONGUA - BOYACA</option>
                                <option value="15466_MONGUI">MONGUI - BOYACA</option>
                                <option value="15469_MONIQUIRA">MONIQUIRA - BOYACA</option>
                                <option value="15476_MOTAVITA">MOTAVITA - BOYACA</option>
                                <option value="15480_MUZO">MUZO - BOYACA</option>
                                <option value="15491_NOBSA">NOBSA - BOYACA</option>
                                <option value="15494_NUEVO COLON">NUEVO COLON - BOYACA</option>
                                <option value="15500_OICATA">OICATA - BOYACA</option>
                                <option value="15507_OTANCHE">OTANCHE - BOYACA</option>
                                <option value="15511_PACHAVITA">PACHAVITA - BOYACA</option>
                                <option value="15514_PAEZ">PAEZ - BOYACA</option>
                                <option value="15516_PAIPA">PAIPA - BOYACA</option>
                                <option value="15518_PAJARITO">PAJARITO - BOYACA</option>
                                <option value="15522_PANQUEBA">PANQUEBA - BOYACA</option>
                                <option value="15531_PAUNA">PAUNA - BOYACA</option>
                                <option value="15533_PAYA">PAYA - BOYACA</option>
                                <option value="15537_PAZ DE RIO">PAZ DE RIO - BOYACA</option>
                                <option value="15542_PESCA">PESCA - BOYACA</option>
                                <option value="15550_PISVA">PISVA - BOYACA</option>
                                <option value="15572_PUERTO BOYACA">PUERTO BOYACA - BOYACA</option>
                                <option value="15580_QUIPAMA">QUIPAMA - BOYACA</option>
                                <option value="15599_RAMIRIQUI">RAMIRIQUI - BOYACA</option>
                                <option value="15600_RAQUIRA">RAQUIRA - BOYACA</option>
                                <option value="15621_RONDON">RONDON - BOYACA</option>
                                <option value="15632_SABOYA">SABOYA - BOYACA</option>
                                <option value="15638_SACHICA">SACHICA - BOYACA</option>
                                <option value="15646_SAMACA">SAMACA - BOYACA</option>
                                <option value="15660_SAN EDUARDO">SAN EDUARDO - BOYACA</option>
                                <option value="15664_SAN JOSE">SAN JOSE DE PARE - BOYACA</option>
                                <option value="15667_SAN LUIS">SAN LUIS DE GACENO - BOYACA</option>
                                <option value="15673_SAN MATEO">SAN MATEO - BOYACA</option>
                                <option value="15676_SAN MIGUEL DE SEMA">SAN MIGUEL DE SEMA - BOYACA</option>
                                <option value="15681_SAN PABLO DE BORBUR">SAN PABLO DE BORBUR - BOYACA</option>
                                <option value="15686_SANTANA">SANTANA - BOYACA</option>
                                <option value="15690_SANTA MARIA">SANTA MARIA - BOYACA</option>
                                <option value="15693_SANTA ROSA DE VITERBO">SANTA ROSA DE VITERBO - BOYACA</option>
                                <option value="15696_SANTA SOFIA">SANTA SOFIA - BOYACA</option>
                                <option value="15720_SATIVANORTE">SATIVANORTE - BOYACA</option>
                                <option value="15723_SATIVASUR">SATIVASUR - BOYACA</option>
                                <option value="15740_SIACHOQUE">SIACHOQUE - BOYACA</option>
                                <option value="15753_SOATA">SOATA - BOYACA</option>
                                <option value="15755_SOCOTA">SOCOTA - BOYACA</option>
                                <option value="15757_SOCHA">SOCHA - BOYACA</option>
                                <option value="15759_SOGAMOSO">SOGAMOSO - BOYACA</option>
                                <option value="15761_SOMONDOCO">SOMONDOCO - BOYACA</option>
                                <option value="15762_SORA">SORA - BOYACA</option>
                                <option value="15763_SOTAQUIRA">SOTAQUIRA - BOYACA</option>
                                <option value="15764_SORACA">SORACA - BOYACA</option>
                                <option value="15774_SUSACON">SUSACON - BOYACA</option>
                                <option value="15776_SUTAMARCHAN">SUTAMARCHAN - BOYACA</option>
                                <option value="15778_SUTATENZA">SUTATENZA - BOYACA</option>
                                <option value="15790_TASCO">TASCO - BOYACA</option>
                                <option value="15798_TENZA">TENZA - BOYACA</option>
                                <option value="15804_TIBANA">TIBANA - BOYACA</option>
                                <option value="15806_TIBASOSA">TIBASOSA - BOYACA</option>
                                <option value="15808_TINJACA">TINJACA - BOYACA</option>
                                <option value="15810_TIPACOQUE">TIPACOQUE - BOYACA</option>
                                <option value="15814_TOCA">TOCA - BOYACA</option>
                                <option value="15816_TOGUI">TOGUI - BOYACA</option>
                                <option value="15820_TOPAGA">TOPAGA - BOYACA</option>
                                <option value="15822_TOTA">TOTA - BOYACA</option>
                                <option value="15832_TUNUNGUA">TUNUNGUA - BOYACA</option>
                                <option value="15835_TURMEQUE">TURMEQUE - BOYACA</option>
                                <option value="15837_TUTA">TUTA - BOYACA</option>
                                <option value="15839_TUTASA">TUTASA - BOYACA</option>
                                <option value="15842_UMBITA">UMBITA - BOYACA</option>
                                <option value="15861_VENTAQUEMADA">VENTAQUEMADA - BOYACA</option>
                                <option value="15879_VIRACACHA">VIRACACHA - BOYACA</option>
                                <option value="15897_ZETAQUIRA">ZETAQUIRA - BOYACA</option>
                                <option value="17001_MANIZALES">MANIZALES - CALDAS</option>
                                <option value="17013_AGUADAS">AGUADAS - CALDAS</option>
                                <option value="17042_ANSERMA">ANSERMA - CALDAS</option>
                                <option value="17050_ARANZAZU">ARANZAZU - CALDAS</option>
                                <option value="17088_BELALCAZAR">BELALCAZAR - CALDAS</option>
                                <option value="17174_CHINCHINA">CHINCHINA - CALDAS</option>
                                <option value="17272_FILADELFIA">FILADELFIA - CALDAS</option>
                                <option value="17380_LA DORADA">LA DORADA - CALDAS</option>
                                <option value="17388_LA MERCED">LA MERCED - CALDAS</option>
                                <option value="17433_MANZANARES">MANZANARES - CALDAS</option>
                                <option value="17442_MARMATO">MARMATO - CALDAS</option>
                                <option value="17444_MARQUETALIA">MARQUETALIA - CALDAS</option>
                                <option value="17446_MARULANDA">MARULANDA - CALDAS</option>
                                <option value="17486_NEIRA">NEIRA - CALDAS</option>
                                <option value="17495_NORCASIA">NORCASIA - CALDAS</option>
                                <option value="17513_PACORA">PACORA - CALDAS</option>
                                <option value="17524_PALESTINA">PALESTINA - CALDAS</option>
                                <option value="17541_PENSILVANIA">PENSILVANIA - CALDAS</option>
                                <option value="17614_RIOSUCIO">RIOSUCIO - CALDAS</option>
                                <option value="17616_RISARALDA">RISARALDA - CALDAS</option>
                                <option value="17653_SALAMINA">SALAMINA - CALDAS</option>
                                <option value="17662_SAMANA">SAMANA - CALDAS</option>
                                <option value="17665_SAN JOSE">SAN JOSE - CALDAS</option>
                                <option value="17777_SUPIA">SUPIA - CALDAS</option>
                                <option value="17867_VICTORIA">VICTORIA - CALDAS</option>
                                <option value="17873_VILLAMARIA">VILLAMARIA - CALDAS</option>
                                <option value="17877_VITERBO">VITERBO - CALDAS</option>
                                <option value="17991_ARAUCA">ARAUCA - CALDAS</option>
                                <option value="17992_BOLIVIA">BOLIVIA - CALDAS</option>
                                <option value="17993_FLORENCIA">FLORENCIA - CALDAS</option>
                                <option value="17995_SAN FELIX">SAN FELIX - CALDAS</option>
                                <option value="17996_SAN JOSE DE RISARALDA">SAN JOSE DE RISARALDA - CALDAS</option>
                                <option value="17998_ARBOLEDA">ARBOLEDA - CALDAS</option>
                                <option value="18001_FLORENCIA">FLORENCIA - CAQUETA</option>
                                <option value="18029_ALBANIA">ALBANIA - CAQUETA</option>
                                <option value="18094_BELEN DE LOS ANDAQUIES">BELEN DE LOS ANDAQUIES - CAQUETA</option>
                                <option value="18150_CARTAGENA DEL CHAIRA">CARTAGENA DEL CHAIRA - CAQUETA</option>
                                <option value="18205_CURILLO">CURILLO - CAQUETA</option>
                                <option value="18247_EL DONCELLO">EL DONCELLO - CAQUETA</option>
                                <option value="18256_EL PAUJIL">EL PAUJIL - CAQUETA</option>
                                <option value="18410_LA MONTANITA">LA MONTANITA - CAQUETA</option>
                                <option value="18460_MILAN">MILAN - CAQUETA</option>
                                <option value="18479_MORELIA">MORELIA - CAQUETA</option>
                                <option value="18592_PUERTO RICO">PUERTO RICO - CAQUETA</option>
                                <option value="18610_SAN JOSE DE FRAGUA">SAN JOSE DE FRAGUA - CAQUETA</option>
                                <option value="18753_SAN VICENTE DEL CAGUAN">SAN VICENTE DEL CAGUAN - CAQUETA</option>
                                <option value="18765_SOLANO">SOLANO - CAQUETA</option>
                                <option value="18785_SOLITA">SOLITA - CAQUETA</option>
                                <option value="18806_VALPARAISO">VALPARAISO - CAQUETA</option>
                                <option value="19001_POPAYAN">POPAYAN - CAUCA</option>
                                <option value="19022_ALMAGUER">ALMAGUER - CAUCA</option>
                                <option value="19050_ARGELIA">ARGELIA - CAUCA</option>
                                <option value="19075_BALBOA">BALBOA - CAUCA</option>
                                <option value="19100_BOLIVAR">BOLIVAR - CAUCA</option>
                                <option value="19110_BUENOS AIRES">BUENOS AIRES - CAUCA</option>
                                <option value="19130_CAJIBIO">CAJIBIO - CAUCA</option>
                                <option value="19137_CALDONO">CALDONO - CAUCA</option>
                                <option value="19142_CALOTO">CALOTO - CAUCA</option>
                                <option value="19212_CORINTO">CORINTO - CAUCA</option>
                                <option value="19256_EL TAMBO">EL TAMBO - CAUCA</option>
                                <option value="19290_FLORENCIA">FLORENCIA - CAUCA</option>
                                <option value="19318_GUAPI">GUAPI - CAUCA</option>
                                <option value="19355_INZA">INZA - CAUCA</option>
                                <option value="19364_JAMBALO">JAMBALO - CAUCA</option>
                                <option value="19392_LA SIERRA">LA SIERRA - CAUCA</option>
                                <option value="19397_LA VEGA">LA VEGA - CAUCA</option>
                                <option value="19418_LOPEZ">LOPEZ - CAUCA</option>
                                <option value="19450_MERCADERES">MERCADERES - CAUCA</option>
                                <option value="19455_MIRANDA">MIRANDA - CAUCA</option>
                                <option value="19473_MORALES">MORALES - CAUCA</option>
                                <option value="19513_PADILLA">PADILLA - CAUCA</option>
                                <option value="19517_PAEZ">PAEZ - CAUCA</option>
                                <option value="19532_PATIA(EL BORDO)">PATIA(EL BORDO) - CAUCA</option>
                                <option value="19533_PIAMONTE">PIAMONTE - CAUCA</option>
                                <option value="19548_PIENDAMO">PIENDAMO - CAUCA</option>
                                <option value="19573_PUERTO TEJADA">PUERTO TEJADA - CAUCA</option>
                                <option value="19585_PURACE">PURACE - CAUCA</option>
                                <option value="19622_ROSAS">ROSAS - CAUCA</option>
                                <option value="19693_SAN SEBASTIAN">SAN SEBASTIAN - CAUCA</option>
                                <option value="19698_SANTANDER DE QUILICHAO">SANTANDER DE QUILICHAO - CAUCA</option>
                                <option value="19701_SANTA ROSA">SANTA ROSA - CAUCA</option>
                                <option value="19743_SILVIA">SILVIA - CAUCA</option>
                                <option value="19760_SOTARA">SOTARA - CAUCA</option>
                                <option value="19780_SUAREZ">SUAREZ - CAUCA</option>
                                <option value="19785_SUCRE">SUCRE - CAUCA</option>
                                <option value="19807_TIMBIO">TIMBIO - CAUCA</option>
                                <option value="19809_TIMBIQUI">TIMBIQUI - CAUCA</option>
                                <option value="19821_TORIBIO">TORIBIO - CAUCA</option>
                                <option value="19824_TOTORO">TOTORO - CAUCA</option>
                                <option value="19845_VILLA RICA">VILLA RICA - CAUCA</option>
                                <option value="20001_VALLEDUPAR">VALLEDUPAR - CESAR</option>
                                <option value="20011_AGUACHICA">AGUACHICA - CESAR</option>
                                <option value="20013_AGUSTIN COSAZZI">AGUSTIN CODAZZI - CESAR</option>
                                <option value="20032_ASTREA">ASTREA - CESAR</option>
                                <option value="20045_BECERRIL">BECERRIL - CESAR</option>
                                <option value="20060_BOSCONIA">BOSCONIA - CESAR</option>
                                <option value="20175_CHIMICHAGUA">CHIMICHAGUA - CESAR</option>
                                <option value="20178_CHIRIGUANA">CHIRIGUANA - CESAR</option>
                                <option value="20228_CURUMANI">CURUMANI - CESAR</option>
                                <option value="20238_EL COPEY">EL COPEY - CESAR</option>
                                <option value="20250_EL PASO">EL PASO - CESAR</option>
                                <option value="20295_GAMARRA">GAMARRA - CESAR</option>
                                <option value="20310_GONZALEZ">GONZALEZ - CESAR</option>
                                <option value="20383_LA GLORIA">LA GLORIA - CESAR</option>
                                <option value="20400_LA JAGUA DE IBIRICO">LA JAGUA DE IBIRICO - CESAR</option>
                                <option value="20443_MANAURE BALCON DL CESAR">MANAURE BALCON DL CESAR - CESAR</option>
                                <option value="20517_PAILITAS">PAILITAS - CESAR</option>
                                <option value="20550_PELAYA">PELAYA - CESAR</option>
                                <option value="20570_PUEBLO BELLO">PUEBLO BELLO - CESAR</option>
                                <option value="20614_RIO DE ORO">RIO DE ORO - CESAR</option>
                                <option value="20621_LA PAZ">LA PAZ - CESAR</option>
                                <option value="20710_SAN ALBERTO">SAN ALBERTO - CESAR</option>
                                <option value="20750_SAN DIEGO">SAN DIEGO - CESAR</option>
                                <option value="20770_SAN MARTIN">SAN MARTIN - CESAR</option>
                                <option value="20787_TAMALAMEQUE">TAMALAMEQUE - CESAR</option>
                                <option value="23001_MONTERIA">MONTERIA - CORDOBA</option>
                                <option value="23068_AYAPEL">AYAPEL - CORDOBA</option>
                                <option value="23079_BUENAVISTA">BUENAVISTA - CORDOBA</option>
                                <option value="23090_CANALETE">CANALETE - CORDOBA</option>
                                <option value="23162_CERETE">CERETE - CORDOBA</option>
                                <option value="23168_CHIMA">CHIMA - CORDOBA</option>
                                <option value="23182_CHINU">CHINU - CORDOBA</option>
                                <option value="23189_CIENAGA DE ORO">CIENAGA DE ORO - CORDOBA</option>
                                <option value="23300_COTORRA">COTORRA - CORDOBA</option>
                                <option value="23350_LA APARTADA">LA APARTADA - CORDOBA</option>
                                <option value="23417_LORICA">LORICA - CORDOBA</option>
                                <option value="23419_LOS CORDOBAS">LOS CORDOBAS - CORDOBA</option>
                                <option value="23464_MOMIL">MOMIL - CORDOBA</option>
                                <option value="23466_MONTELIBANO">MONTELIBANO - CORDOBA</option>
                                <option value="23500_MOÑITOS">MOÑITOS - CORDOBA</option>
                                <option value="23555_PLANETA RICA">PLANETA RICA - CORDOBA</option>
                                <option value="23570_PUEBLO NUEVO">PUEBLO NUEVO - CORDOBA</option>
                                <option value="23574_PUERTO ESCONDIDO">PUERTO ESCONDIDO - CORDOBA</option>
                                <option value="23580_PUERTO LIBERTADOR">PUERTO LIBERTADOR - CORDOBA</option>
                                <option value="23586_PURISIMA">PURISIMA - CORDOBA</option>
                                <option value="23660_SAHAGUN">SAHAGUN - CORDOBA</option>
                                <option value="23670_SAN ANDRES DE SOTAVENTO">SAN ANDRES DE SOTAVENTO - CORDOBA</option>
                                <option value="23672_SAN ANTERO">SAN ANTERO - CORDOBA</option>
                                <option value="23675_SAN BERNARDO DEL VIENTO">SAN BERNARDO DEL VIENTO - CORDOBA</option>
                                <option value="23678_SAN CARLOS ">SAN CARLOS - CORDOBA</option>
                                <option value="23686_SAN PELAYO">SAN PELAYO - CORDOBA</option>
                                <option value="23807_TIERRALTA">TIERRALTA - CORDOBA</option>
                                <option value="23855_VALENCIA">VALENCIA - CORDOBA</option>
                                <option value="25001_AGUA DE DIOS">AGUA DE DIOS - CUNDINAMARCA</option>
                                <option value="25019_ALBAN">ALBAN - CUNDINAMARCA</option>
                                <option value="25035_ANAPOIMA">ANAPOIMA - CUNDINAMARCA</option>
                                <option value="25040_ANOLAIMA">ANOLAIMA - CUNDINAMARCA</option>
                                <option value="25053_ARBELAEZ">ARBELAEZ - CUNDINAMARCA</option>
                                <option value="25086_BELTRAN">BELTRAN - CUNDINAMARCA</option>
                                <option value="25095_BITUIMA">BITUIMA - CUNDINAMARCA</option>
                                <option value="25099_BOJACA">BOJACA - CUNDINAMARCA</option>
                                <option value="25120_CABRERA">CABRERA - CUNDINAMARCA</option>
                                <option value="25123_CACHIPAY">CACHIPAY - CUNDINAMARCA</option>
                                <option value="25126_CAJICA">CAJICA - CUNDINAMARCA</option>
                                <option value="25148_CAPARRAPI">CAPARRAPI - CUNDINAMARCA</option>
                                <option value="25151_CAQUEZA">CAQUEZA - CUNDINAMARCA</option>
                                <option value="25154_CARMEN DE CARUPA">CARMEN DE CARUPA - CUNDINAMARCA</option>
                                <option value="25168_CHAGUANI">CHAGUANI - CUNDINAMARCA</option>
                                <option value="25175_CHIA">CHIA - CUNDINAMARCA</option>
                                <option value="25178_CHIPAQUE">CHIPAQUE - CUNDINAMARCA</option>
                                <option value="25181_CHOACHI">CHOACHI - CUNDINAMARCA</option>
                                <option value="25183_CHOCONTA">CHOCONTA - CUNDINAMARCA</option>
                                <option value="25200_COGUA">COGUA - CUNDINAMARCA</option>
                                <option value="25214_COTA">COTA - CUNDINAMARCA</option>
                                <option value="25224_CUCUNUBA">CUCUNUBA - CUNDINAMARCA</option>
                                <option value="25245_EL COLEGIO">EL COLEGIO - CUNDINAMARCA</option>
                                <option value="25258_EL PENON">EL PENON - CUNDINAMARCA</option>
                                <option value="25260_EL ROSAL">EL ROSAL - CUNDINAMARCA</option>
                                <option value="25269_FACATATIVA">FACATATIVA - CUNDINAMARCA</option>
                                <option value="25279_FOMEQUE">FOMEQUE - CUNDINAMARCA</option>
                                <option value="25281_FOSCA">FOSCA - CUNDINAMARCA</option>
                                <option value="25286_FUNZA">FUNZA - CUNDINAMARCA</option>
                                <option value="25288_FUQUENE">FUQUENE - CUNDINAMARCA</option>
                                <option value="25290_FUSAGASUGA">FUSAGASUGA - CUNDINAMARCA</option>
                                <option value="25293_GACHALA">GACHALA - CUNDINAMARCA</option>
                                <option value="25295_GACHANCIPA">GACHANCIPA - CUNDINAMARCA</option>
                                <option value="25297_GACHETA">GACHETA - CUNDINAMARCA</option>
                                <option value="25299_GAMA">GAMA - CUNDINAMARCA</option>
                                <option value="25307_GIRARDOT">GIRARDOT - CUNDINAMARCA</option>
                                <option value="25312_GRANADA">GRANADA - CUNDINAMARCA</option>
                                <option value="25317_GUACHETA">GUACHETA - CUNDINAMARCA</option>
                                <option value="25320_GUADUAS">GUADUAS - CUNDINAMARCA</option>
                                <option value="25322_GUASCA">GUASCA - CUNDINAMARCA</option>
                                <option value="25324_GUATAQUI">GUATAQUI - CUNDINAMARCA</option>
                                <option value="25326_GUATAVITA">GUATAVITA - CUNDINAMARCA</option>
                                <option value="25328_GUAYABAL DE SIQUIMA">GUAYABAL DE SIQUIMA - CUNDINAMARCA</option>
                                <option value="25335_GUAYABETAL">GUAYABETAL - CUNDINAMARCA</option>
                                <option value="25339_GUTIERREZ">GUTIERREZ - CUNDINAMARCA</option>
                                <option value="25368_JERUSALEN">JERUSALEN - CUNDINAMARCA</option>
                                <option value="25372_JUNIN">JUNIN - CUNDINAMARCA</option>
                                <option value="25377_LA CALERA">LA CALERA - CUNDINAMARCA</option>
                                <option value="25386_LA MESA">LA MESA - CUNDINAMARCA</option>
                                <option value="25394_LA PALMA">LA PALMA - CUNDINAMARCA</option>
                                <option value="25398_LA PEÑA">LA PEÑA - CUNDINAMARCA</option>
                                <option value="25402_LA VEGA">LA VEGA - CUNDINAMARCA</option>
                                <option value="25407_LENGUAZAQUE">LENGUAZAQUE - CUNDINAMARCA</option>
                                <option value="25426_MACHETA">MACHETA - CUNDINAMARCA</option>
                                <option value="25430_MADRID">MADRID - CUNDINAMARCA</option>
                                <option value="25436_MANTA">MANTA - CUNDINAMARCA</option>
                                <option value="25438_MEDINA">MEDINA - CUNDINAMARCA</option>
                                <option value="25473_MOSQUERA">MOSQUERA - CUNDINAMARCA</option>
                                <option value="25483_NARINO">NARINO - CUNDINAMARCA</option>
                                <option value="25486_NEMOCON">NEMOCON - CUNDINAMARCA</option>
                                <option value="25488_NILO">NILO - CUNDINAMARCA</option>
                                <option value="25489_NIMAIMA">NIMAIMA - CUNDINAMARCA</option>
                                <option value="25491_NOCAIMA">NOCAIMA - CUNDINAMARCA</option>
                                <option value="25506_VENECIA">VENECIA - CUNDINAMARCA</option>
                                <option value="25513_PACHO">PACHO - CUNDINAMARCA</option>
                                <option value="25518_PAIME">PAIME - CUNDINAMARCA</option>
                                <option value="25524_PANDI">PANDI - CUNDINAMARCA</option>
                                <option value="25530_PARATEBUENO">PARATEBUENO - CUNDINAMARCA</option>
                                <option value="25535_PASCA">PASCA - CUNDINAMARCA</option>
                                <option value="25572_PUERTO SALGAR">PUERTO SALGAR - CUNDINAMARCA</option>
                                <option value="25580_PULI">PULI - CUNDINAMARCA</option>
                                <option value="25592_QUEBRADANEGRA">QUEBRADANEGRA - CUNDINAMARCA</option>
                                <option value="25594_QUETAME">QUETAME - CUNDINAMARCA</option>
                                <option value="25596_QUIPILE">QUIPILE - CUNDINAMARCA</option>
                                <option value="25599_APULO">APULO - CUNDINAMARCA</option>
                                <option value="25612_RICAURTE">RICAURTE - CUNDINAMARCA</option>
                                <option value="25645_S.ANTONIO DE TEQUENDAMA">S.ANTONIO DE TEQUENDAMA - CUNDINAMARCA</option>
                                <option value="25649_SAN BERNARDO">SAN BERNARDO - CUNDINAMARCA</option>
                                <option value="25653_SAN CAYETANO">SAN CAYETANO - CUNDINAMARCA</option>
                                <option value="25658_SAN FRANCISCO">SAN FRANCISCO - CUNDINAMARCA</option>
                                <option value="25662_SAN JUAN DE RIO SECO">SAN JUAN DE RIO SECO - CUNDINAMARCA</option>
                                <option value="25718_SASAIMA">SASAIMA - CUNDINAMARCA</option>
                                <option value="25736_SESQUILE">SESQUILE - CUNDINAMARCA</option>
                                <option value="25740_SIBATE">SIBATE - CUNDINAMARCA</option>
                                <option value="25743_SILVANIA">SILVANIA - CUNDINAMARCA</option>
                                <option value="25745_SIMIJACA">SIMIJACA - CUNDINAMARCA</option>
                                <option value="25754_SOACHA">SOACHA - CUNDINAMARCA</option>
                                <option value="25758_SOPO">SOPO - CUNDINAMARCA</option>
                                <option value="25769_SUBACHOQUE">SUBACHOQUE - CUNDINAMARCA</option>
                                <option value="25772_SUESCA">SUESCA - CUNDINAMARCA</option>
                                <option value="25777_SUPATA">SUPATA - CUNDINAMARCA</option>
                                <option value="25779_SUSA">SUSA - CUNDINAMARCA</option>
                                <option value="25781_SUTATAUSA">SUTATAUSA - CUNDINAMARCA</option>
                                <option value="25785_TABIO">TABIO - CUNDINAMARCA</option>
                                <option value="25793_TAUSA">TAUSA - CUNDINAMARCA</option>
                                <option value="25797_TENA">TENA - CUNDINAMARCA</option>
                                <option value="25799_TENJO">TENJO - CUNDINAMARCA</option>
                                <option value="25805_TIBACUY">TIBACUY - CUNDINAMARCA</option>
                                <option value="25807_TIBIRITA">TIBIRITA - CUNDINAMARCA</option>
                                <option value="25815_TOCAIMA">TOCAIMA - CUNDINAMARCA</option>
                                <option value="25817_TOCANCIPA">TOCANCIPA - CUNDINAMARCA</option>
                                <option value="25823_TOPAIPI">TOPAIPI - CUNDINAMARCA</option>
                                <option value="25839_UBALA">UBALA - CUNDINAMARCA</option>
                                <option value="25841_UBAQUE">UBAQUE - CUNDINAMARCA</option>
                                <option value="25843_UBATE">UBATE - CUNDINAMARCA</option>
                                <option value="25845_UNE">UNE - CUNDINAMARCA</option>
                                <option value="25851_UTICA">UTICA - CUNDINAMARCA</option>
                                <option value="25862_VERGARA">VERGARA - CUNDINAMARCA</option>
                                <option value="25867_VIANI">VIANI - CUNDINAMARCA</option>
                                <option value="25871_VILLAGOMEZ">VILLAGOMEZ - CUNDINAMARCA</option>
                                <option value="25873_VILLAPINZON">VILLAPINZON - CUNDINAMARCA</option>
                                <option value="25875_VILLETA">VILLETA - CUNDINAMARCA</option>
                                <option value="25878_VIOTA">VIOTA - CUNDINAMARCA</option>
                                <option value="25885_YACOPI">YACOPI - CUNDINAMARCA</option>
                                <option value="25898_ZIPACON">ZIPACON - CUNDINAMARCA</option>
                                <option value="25899_ZIPAQUIRA">ZIPAQUIRA - CUNDINAMARCA</option>
                                <option value="26763_BOGOTA">BOGOTA D.C - BOGOTA D.C</option>
                                <option value="27001_QUIBDO">QUIBDO - CHOCO</option>
                                <option value="27006_ACANDI">ACANDI - CHOCO</option>
                                <option value="27025_ALTO BAUDO">ALTO BAUDO - CHOCO</option>
                                <option value="27050_ATRATO">ATRATO - CHOCO</option>
                                <option value="27073_BAGADO">BAGADO - CHOCO</option>
                                <option value="27075_BAHIA SOLANO">BAHIA SOLANO - CHOCO</option>
                                <option value="27077_BAJO BAUDO">BAJO BAUDO - CHOCO</option>
                                <option value="27082_BAJO SAN JUAN">BAJO SAN JUAN - CHOCO</option>
                                <option value="27086_BELEN DE BAJIRA">BELEN DE BAJIRA - CHOCO</option>
                                <option value="27099_BOJAYA">BOJAYA - CHOCO</option>
                                <option value="27135_CANTON DEL SAN PABLO">CANTON DEL SAN PABLO - CHOCO</option>
                                <option value="27150_CARMEN DEL DARIEN">CARMEN DEL DARIEN - CHOCO</option>
                                <option value="27160_CERTEGUI">CERTEGUI - CHOCO</option>
                                <option value="27205_CONDOTO">CONDOTO - CHOCO</option>
                                <option value="27245_EL CARMEN">EL CARMEN - CHOCO</option>
                                <option value="27250_EL LITORAL DEL SAN JUAN">EL LITOARL DEL SAN JUAN - CHOCO</option>
                                <option value="27361_ITSMINA">ITSMINA - CHOCO</option>
                                <option value="27372_JURADO">JURADO - CHOCO</option>
                                <option value="27413_LLORO">LLORO - CHOCO</option>
                                <option value="27425_MEDIO ATRATO">MEDIO ATRATO - CHOCÓ</option>
                                <option value="27430_MEDIO BAUDO">MEDIO BAUDO - CHOCO</option>
                                <option value="27450_MEDIO SAN JUAN">MEDIO SAN JUAN - CHOCO</option>
                                <option value="27491_NOVITA">NOVITA - CHOCO</option>
                                <option value="27495_NUQUI">NUQUI - CHOCO</option>
                                <option value="27580_RÍO IRO">RÍO IRO - CHOCÓ</option>
                                <option value="27600_RIO QUITO">RIO QUITO - CHOCO</option>
                                <option value="27615_RIOSUCIO">RIOSUCIO - CHOCO</option>
                                <option value="27660_SAN">SAN JOSE DEL PALMAR - CHOCO</option>
                                <option value="27745_SIPI">SIPI - CHOCO</option>
                                <option value="27787_TADO">TADO - CHOCO</option>
                                <option value="27800_UNGUIA">UNGUIA - CHOCO</option>
                                <option value="27810_UNION PANAMERICANA">UNION PANAMERICANA - CHOCO</option>
                                <option value="41001_NEIVA">NEIVA - HUILA</option>
                                <option value="41006_ACEVEDO">ACEVEDO - HUILA</option>
                                <option value="41013_AGRADO">AGRADO - HUILA</option>
                                <option value="41016_AIPE">AIPE - HUILA</option>
                                <option value="41020_ALGECIRAS">ALGECIRAS - HUILA</option>
                                <option value="41026_ALTAMIRA">ALTAMIRA - HUILA</option>
                                <option value="41078_BARAYA">BARAYA - HUILA</option>
                                <option value="41132_CAMPOALEGRE">CAMPOALEGRE - HUILA</option>
                                <option value="41206_COLOMBIA">COLOMBIA - HUILA</option>
                                <option value="41244_ELIAS">ELIAS - HUILA</option>
                                <option value="41298_GARZON">GARZON - HUILA</option>
                                <option value="41306_GIGANTE">GIGANTE - HUILA</option>
                                <option value="41319_GUADALUPE">GUADALUPE - HUILA</option>
                                <option value="41349_HOBO">HOBO - HUILA</option>
                                <option value="41357_IQUIRA">IQUIRA - HUILA</option>
                                <option value="41359_ISNOS">ISNOS - HUILA</option>
                                <option value="41378_LA ARGENTINA">LA ARGENTINA - HUILA</option>
                                <option value="41396_LA PLATA">LA PLATA - HUILA</option>
                                <option value="41483_NATAGA">NATAGA - HUILA</option>
                                <option value="41503_OPORAPA">OPORAPA - HUILA</option>
                                <option value="41518_PAICOL">PAICOL - HUILA</option>
                                <option value="41524_PALERMO">PALERMO - HUILA</option>
                                <option value="41530_PALESTINA">PALESTINA - HUILA</option>
                                <option value="41548_PITAL">PITAL - HUILA</option>
                                <option value="41551_PITALITO">PITALITO - HUILA</option>
                                <option value="41615_RIVERA">RIVERA - HUILA</option>
                                <option value="41660_SALADOBLANCO">SALADOBLANCO - HUILA</option>
                                <option value="41668_SAN AGUSTIN">SAN AGUSTIN - HUILA</option>
                                <option value="41676_SANTA MARIA">SANTA MARIA - HUILA</option>
                                <option value="41770_SUAZA">SUAZA - HUILA</option>
                                <option value="41791_TARQUI">TARQUI - HUILA</option>
                                <option value="41797_TESALIA">TESALIA - HUILA</option>
                                <option value="41799_TELLO">TELLO - HUILA</option>
                                <option value="41801_TERUEL">TERUEL - HUILA</option>
                                <option value="41807_TIMANA">TIMANA - HUILA</option>
                                <option value="41872_VILLAVIEJA">VILLAVIEJA - HUILA</option>
                                <option value="41885_YAGUARA">YAGUARA - HUILA</option>
                                <option value="44001_RIOHACHA">RIOHACHA - LA GUAJIRA</option>
                                <option value="44035_ALBANIA">ALBANIA - LA GUAJIRA</option>
                                <option value="44078_BARRANCAS">BARRANCAS - LA GUAJIRA</option>
                                <option value="44090_DIBULLA">DIBULLA - LA GUAJIRA</option>
                                <option value="44098_DISTRACCION">DISTRACCION - LA GUAJIRA</option>
                                <option value="44110_EL MOLINO">EL MOLINO - LA GUAJIRA</option>
                                <option value="44279_FONSECA">FONSECA - LA GUAJIRA</option>
                                <option value="44378_HATONUEVO">HATONUEVO - LA GUAJIRA</option>
                                <option value="44420_LA JAGUA DEL PILAR">LA JAGUA DEL PILAR - LA GUAJIRA</option>
                                <option value="44430_MAICAO">MAICAO - LA GUAJIRA</option>
                                <option value="44560_MANAURE">MANAURE - LA GUAJIRA</option>
                                <option value="44650_SAN JUAN DEL CESAR">SAN JUAN DEL CESAR - LA GUAJIRA</option>
                                <option value="44847_URIBIA">URIBIA - LA GUAJIRA</option>
                                <option value="44855_URUMITA">URUMITA - LA GUAJIRA</option>
                                <option value="44874_VILLANUEVA">VILLANUEVA - LA GUAJIRA</option>
                                <option value="47001_SANTA MARTA">SANTA MARTA - MAGDALENA</option>
                                <option value="47030_ALGARROBO">ALGARROBO - MAGDALENA</option>
                                <option value="47053_ARACATACA">ARACATACA - MAGDALENA</option>
                                <option value="47058_ARIGUANI">ARIGUANI - MAGDALENA</option>
                                <option value="47161_CERRO DE SAN ANTONIO">CERRO DE SAN ANTONIO - MAGDALENA</option>
                                <option value="47170_CHIVOLO">CHIVOLO - MAGDALENA</option>
                                <option value="47189_CIENAGA">CIENAGA - MAGDALENA</option>
                                <option value="47205_CONCORDIA">CONCORDIA - MAGDALENA</option>
                                <option value="47245_EL BANCO">EL BANCO - MAGDALENA</option>
                                <option value="47258_EL PIÑON">EL PIÑON - MAGDALENA</option>
                                <option value="47268_EL RETEN">EL RETEN - MAGDALENA</option>
                                <option value="47288_FUNDACION">FUNDACION - MAGDALENA</option>
                                <option value="47318_GUAMAL">GUAMAL - MAGDALENA</option>
                                <option value="47460_NUEVA">NUEVA GRANADA - MAGDALENA</option>
                                <option value="47541_PEDRAZA">PEDRAZA - MAGDALENA</option>
                                <option value="47545_PIJIÑO">PIJIÑO DEL CARMEN - MAGDALENA</option>
                                <option value="47551_PIVIJAY">PIVIJAY - MAGDALENA</option>
                                <option value="47555_PLATO">PLATO - MAGDALENA</option>
                                <option value="47570_PUEBLOVIEJO">PUEBLOVIEJO - MAGDALENA</option>
                                <option value="47605_REMOLINO">REMOLINO - MAGDALENA</option>
                                <option value="47660_SABANAS">SABANAS DE SAN ANGEL - MAGDALENA</option>
                                <option value="47675_SALAMINA">SALAMINA - MAGDALENA</option>
                                <option value="47692_SAN SEBASTIAN BUENAVIST">SAN SEBASTIAN BUENAVIST - MAGDALENA</option>
                                <option value="47703_SAN ZENON">SAN ZENON - MAGDALENA</option>
                                <option value="47707_SANTA ANA">SANTA ANA - MAGDALENA</option>
                                <option value="47720_SANTA BARBARA DE PINTO">SANTA BARBARA DE PINTO - MAGDALENA</option>
                                <option value="47745_SITIONUEVO">SITIONUEVO - MAGDALENA</option>
                                <option value="47798_TENERIFE">TENERIFE - MAGDALENA</option>
                                <option value="47960_ZAPAYAN">ZAPAYAN - MAGDALENA</option>
                                <option value="47980_ZONA BANANERA">ZONA BANANERA - MAGDALENA</option>
                                <option value="50001_VILLAVICENCIO">VILLAVICENCIO - META</option>
                                <option value="50006_ACACIAS">ACACIAS - META</option>
                                <option value="50110_BARRANCA DE UPIA">BARRANCA DE UPIA - META</option>
                                <option value="50124_CABUYARO">CABUYARO - META</option>
                                <option value="50150_CASTILLA LA NUEVA">CASTILLA LA NUEVA - META</option>
                                <option value="50223_CUBARRAL">CUBARRAL - META</option>
                                <option value="50226_CUMARAL">CUMARAL - META</option>
                                <option value="50245_EL CALVARIO">EL CALVARIO - META</option>
                                <option value="50251_EL CASTILLO">EL CASTILLO - META</option>
                                <option value="50270_EL DORADO">EL DORADO - META</option>
                                <option value="50287_FUENTE DE ORO">FUENTE DE ORO - META</option>
                                <option value="50313_GRANADA">GRANADA - META</option>
                                <option value="50318_GUAMAL">GUAMAL - META</option>
                                <option value="50325_MAPIRIPAN">MAPIRIPAN - META</option>
                                <option value="50330_MESETAS">MESETAS - META</option>
                                <option value="50350_LA MACARENA">LA MACARENA - META</option>
                                <option value="50370_LA URIBE">LA URIBE - META</option>
                                <option value="50400_LEJANIAS">LEJANIAS - META</option>
                                <option value="50450_PUERTO CONCORDIA">PUERTO CONCORDIA - META</option>
                                <option value="50568_PUERTO GAITAN">PUERTO GAITAN - META</option>
                                <option value="50573_PUERTO LOPEZ">PUERTO LOPEZ - META</option>
                                <option value="50577_PUERTO LLERAS">PUERTO LLERAS - META</option>
                                <option value="50590_PUERTO RICO">PUERTO RICO - META</option>
                                <option value="50606_RESTREPO">RESTREPO - META</option>
                                <option value="50680_SAN CARLOS DE GUAROA">SAN CARLOS DE GUAROA - META</option>
                                <option value="50683_SAN JUAN DE ARAMA">SAN JUAN DE ARAMA - META</option>
                                <option value="50686_SAN JUANITO">SAN JUANITO - META</option>
                                <option value="50689_SAN MARTIN">SAN MARTIN - META</option>
                                <option value="50711_VISTA HERMOSA">VISTA HERMOSA - META</option>
                                <option value="52001_PASTO">PASTO - NARIÑO</option>
                                <option value="52019_ALBAN">ALBAN - NARIÑO</option>
                                <option value="52022_ALDANA">ALDANA - NARIÑO</option>
                                <option value="52036_ANCUYA">ANCUYA - NARIÑO</option>
                                <option value="52051_ARBOLEDA">ARBOLEDA - NARIÑO</option>
                                <option value="52079_BARBACOAS">BARBACOAS - NARIÑO</option>
                                <option value="52083_BELEN">BELEN - NARIÑO</option>
                                <option value="52110_BUESACO">BUESACO - NARIÑO</option>
                                <option value="52203_COLON">COLON - NARIÑO</option>
                                <option value="52207_CONSACA">CONSACA - NARIÑO</option>
                                <option value="52210_CONTADERO">CONTADERO - NARIÑO</option>
                                <option value="52215_CORDOBA">CORDOBA - NARIÑO</option>
                                <option value="52224_CUASPUD">CUASPUD - NARIÑO</option>
                                <option value="52227_CUMBAL">CUMBAL - NARIÑO</option>
                                <option value="52233_CUMBITARA">CUMBITARA - NARIÑO</option>
                                <option value="52240_CHACHAGUI">CHACHAGUI - NARIÑO</option>
                                <option value="52250_EL CHARCO">EL CHARCO - NARIÑO</option>
                                <option value="52254_EL PENOL">EL PENOL - NARINO</option>
                                <option value="52256_EL ROSARIO">EL ROSARIO - NARIÑO</option>
                                <option value="52258_EL TABLON">EL TABLON - NARIÑO</option>
                                <option value="52260_EL TAMBO">EL TAMBO - NARIÑO</option>
                                <option value="52287_FUNES">FUNES - NARIÑO</option>
                                <option value="52317_GUACHUCAL">GUACHUCAL - NARIÑO</option>
                                <option value="52320_GUAITARILLA">GUAITARILLA - NARIÑ</option>
                                <option value="52323_GUALMATAN">GUALMATAN - NARIÑO</option>
                                <option value="52352_ILES">ILES - NARIÑO</option>
                                <option value="52354_IMUES">IMUES - NARIÑO</option>
                                <option value="52356_IPIALES">IPIALES - NARIÑO</option>
                                <option value="52378_LA CRUZ">LA CRUZ - NARIÑO</option>
                                <option value="52381_LA FLORIDA">LA FLORIDA - NARIÑO</option>
                                <option value="52385_LA LLANADA">LA LLANADA - NARIÑO</option>
                                <option value="52390_LA TOLA">LA TOLA - NARIÑO</option>
                                <option value="52399_LA UNION">LA UNION - NARIÑO</option>
                                <option value="52405_LEIVA">LEIVA - NARIÑO</option>
                                <option value="52411_LINARES">LINARES - NARIÑO</option>
                                <option value="52418_LOS ANDES">LOS ANDES - NARIÑO</option>
                                <option value="52427_MAGUI">MAGUI - NARIÑO</option>
                                <option value="52435_MALLAMA">MALLAMA - NARIÑO</option>
                                <option value="52473_MOSQUERA">MOSQUERA - NARIÑO</option>
                                <option value="52480_NARIÑO">NARIÑO - NARIÑO</option>
                                <option value="52490_OLAYA HERRERA">OLAYA HERRERA - NARIÑO</option>
                                <option value="52506_OSPINA">OSPINA - NARIÑO</option>
                                <option value="52520_FRANCISCO PIZARRO">FRANCISCO PIZARRO - NARIÑO</option>
                                <option value="52540_POLICARPA">POLICARPA - NARIÑO</option>
                                <option value="52560_POTOSI">POTOSI - NARIÑO</option>
                                <option value="52565_PROVIDENCIA">PROVIDENCIA - NARIÑO</option>
                                <option value="52573_PUERRES">PUERRES - NARIÑO</option>
                                <option value="52585_PUPIALES">PUPIALES - NARIÑO</option>
                                <option value="52612_RICAURTE">RICAURTE - NARIÑO</option>
                                <option value="52621_ROBERTO PAYAN">ROBERTO PAYAN - NARIÑO</option>
                                <option value="52678_SAMANIEGO">SAMANIEGO - NARIÑO</option>
                                <option value="52683_SANDONA">SANDONA - NARIÑO</option>
                                <option value="52685_SAN BERNARDO">SAN BERNARDO - NARIÑO</option>
                                <option value="52687_SAN LORENZO">SAN LORENZO - NARIÑO</option>
                                <option value="52693_SAN PABLO">SAN PABLO - NARIÑO</option>
                                <option value="52694_SAN PEDRO DE CARTAGO">SAN PEDRO DE CARTAGO - NARIÑO</option>
                                <option value="52696_SANTA BARBARA">SANTA BARBARA - NARIÑO</option>
                                <option value="52699_SANTACRUZ">SANTACRUZ - NARIÑO</option>
                                <option value="52720_SAPUYES">SAPUYES - NARIÑO</option>
                                <option value="52786_TAMINANGO">TAMINANGO - NARIÑO</option>
                                <option value="52788_TANGUA">TANGUA - NARIÑO</option>
                                <option value="52835_TUMACO">TUMACO - NARIÑO</option>
                                <option value="52838_TUQUERRES">TUQUERRES - NARIÑO</option>
                                <option value="52885_YACUANQUER">YACUANQUER - NARIÑO</option>
                                <option value="54001_CUCUTA">CUCUTA - NORTE SANTANDER</option>
                                <option value="54003_ABREGO">ABREGO - NORTE SANTANDER</option>
                                <option value="54051_ARBOLEDAS">ARBOLEDAS - NORTE SANTANDER</option>
                                <option value="54099_BOCHALEMA">BOCHALEMA - NORTE SANTANDER</option>
                                <option value="54109_BUCARASICA">BUCARASICA - NORTE SANTANDER</option>
                                <option value="54125_CACOTA">CACOTA - NORTE SANTANDER</option>
                                <option value="54128_CACHIRA">CACHIRA - NORTE SANTANDER</option>
                                <option value="54172_CHINACOTA">CHINACOTA - NORTE SANTANDER</option>
                                <option value="54174_CHITAGA">CHITAGA - NORTE SANTANDER</option>
                                <option value="54206_CONVENCION">CONVENCION - NORTE SANTANDER</option>
                                <option value="54223_CUCUTILLA">CUCUTILLA - NORTE SANTANDER</option>
                                <option value="54239_DURANIA">DURANIA - NORTE SANTANDER</option>
                                <option value="54245_EL CARMEN">EL CARMEN - NORTE SANTANDER</option>
                                <option value="54250_EL TARRA">EL TARRA - NORTE SANTANDER</option>
                                <option value="54261_EL ZULIA">EL ZULIA - NORTE SANTANDER</option>
                                <option value="54313_GRAMALOTE">GRAMALOTE - NORTE SANTANDER</option>
                                <option value="54344_HACARI">HACARI - NORTE SANTANDER</option>
                                <option value="54347_HERRAN">HERRAN - NORTE SANTANDER</option>
                                <option value="54377_LABATECA">LABATECA - NORTE SANTANDER</option>
                                <option value="54385_LA ESPERANZA">LA ESPERANZA - NORTE SANTANDER</option>
                                <option value="54398_LA PLAYA">LA PLAYA - NORTE SANTANDER</option>
                                <option value="54405_LOS PATIOS">LOS PATIOS - NORTE SANTANDER</option>
                                <option value="54418_LOURDES">LOURDES - NORTE SANTANDER</option>
                                <option value="54480_MUTISCUA">MUTISCUA - NORTE SANTANDER</option>
                                <option value="54498_OCAÑA">OCAÑA - NORTE SANTANDER</option>
                                <option value="54518_PAMPLONA">PAMPLONA - NORTE SANTANDER</option>
                                <option value="54520_PAMPLONITA">PAMPLONITA - NORTE SANTANDER</option>
                                <option value="54553_PUERTO SANTANDER">PUERTO SANTANDER - NORTE SANTANDER</option>
                                <option value="54599_RAGONVALIA">RAGONVALIA - NORTE SANTANDER</option>
                                <option value="54660_SALAZAR">SALAZAR - NORTE SANTANDER</option>
                                <option value="54670_SAN CALIXTO">SAN CALIXTO - NORTE SANTANDER</option>
                                <option value="54673_SAN CAYETANO">SAN CAYETANO - NORTE SANTANDER</option>
                                <option value="54680_SANTIAGO">SANTIAGO - NORTE SANTANDER</option>
                                <option value="54720_SARDINATA">SARDINATA - NORTE SANTANDER</option>
                                <option value="54743_SILOS">SILOS - NORTE SANTANDER</option>
                                <option value="54800_TEORAMA">TEORAMA - NORTE SANTANDER</option>
                                <option value="54810_TIBU">TIBU - NORTE SANTANDER</option>
                                <option value="54820_TOLEDO">TOLEDO - NORTE SANTANDER</option>
                                <option value="54871_VILLA CARO">VILLA CARO - NORTE SANTANDER</option>
                                <option value="54874_VILLA DEL ROSARIO">VILLA DEL ROSARIO - NORTE SANTANDER</option>
                                <option value="63001_ARMENIA">ARMENIA - QUINDIO</option>
                                <option value="63111_BUENAVISTA">BUENAVISTA - QUINDIO</option>
                                <option value="63130_CALARCA">CALARCA - QUINDIO</option>
                                <option value="63190_CIRCASIA">CIRCASIA - QUINDIO</option>
                                <option value="63212_CORDOBA">CORDOBA - QUINDIO</option>
                                <option value="63272_FILANDIA">FILANDIA - QUINDIO</option>
                                <option value="63302_GENOVA">GENOVA - QUINDIO</option>
                                <option value="63401_LA TEBAIDA">LA TEBAIDA - QUINDIO</option>
                                <option value="63470_MONTENEGRO">MONTENEGRO - QUINDIO</option>
                                <option value="63548_PIJAO">PIJAO - QUINDIO</option>
                                <option value="63594_QUIMBAYA">QUIMBAYA - QUINDIO</option>
                                <option value="63690_SALENTO">SALENTO - QUINDIO</option>
                                <option value="66001_PEREIRA">PEREIRA - RISARALDA</option>
                                <option value="66045_APIA">APIA - RISARALDA</option>
                                <option value="66075_BALBOA">BALBOA - RISARALDA</option>
                                <option value="66088_BELEN DE UMBRIA">BELEN DE UMBRIA - RISARALDA</option>
                                <option value="66170_DOS QUEBRADAS">DOS QUEBRADAS - RISARALDA</option>
                                <option value="66318_GUATICA">GUATICA - RISARALDA</option>
                                <option value="66383_LA CELIA">LA CELIA - RISARALDA</option>
                                <option value="66400_LA VIRGINIA">LA VIRGINIA - RISARALDA</option>
                                <option value="66440_MARSELLA">MARSELLA - RISARALDA</option>
                                <option value="66456_MISTRATO">MISTRATO - RISARALDA</option>
                                <option value="66572_PUEBLO">PUEBLO RICO - RISARALDA</option>
                                <option value="66594_QUINCHIA">QUINCHIA - RISARALDA</option>
                                <option value="66682_SANTA ROSA DE CABAL">SANTA ROSA DE CABAL - RISARALDA</option>
                                <option value="66687_SANTUARIO">SANTUARIO - RISARALDA</option>
                                <option value="68001_BUCARAMANGA">BUCARAMANGA - SANTANDER</option>
                                <option value="68013_AGUADA">AGUADA - SANTANDER</option>
                                <option value="68020_ALBANIA">ALBANIA - SANTANDER</option>
                                <option value="68051_ARATOCA">ARATOCA - SANTANDER</option>
                                <option value="68077_BARBOSA">BARBOSA - SANTANDER</option>
                                <option value="68079_BARICHARA">BARICHARA - SANTANDER</option>
                                <option value="68081_BARRANCABERMEJA">BARRANCABERMEJA - SANTANDER</option>
                                <option value="68092_BETULIA">BETULIA - SANTANDER</option>
                                <option value="68101_BOLIVAR">BOLIVAR - SANTANDER</option>
                                <option value="68121_CABRERA">CABRERA - SANTANDER</option>
                                <option value="68132_CALIFORNIA">CALIFORNIA - SANTANDER</option>
                                <option value="68147_CAPITANEJO">CAPITANEJO - SANTANDER</option>
                                <option value="68152_CARCASI">CARCASI - SANTANDER</option>
                                <option value="68160_CEPITA">CEPITA - SANTANDER</option>
                                <option value="68162_CERRITO">CERRITO - SANTANDER</option>
                                <option value="68167_CHARALA">CHARALA - SANTANDER</option>
                                <option value="68169_CHARTA">CHARTA - SANTANDER</option>
                                <option value="68176_CHIMA">CHIMA - SANTANDER</option>
                                <option value="68179_CHIPATA">CHIPATA - SANTANDER</option>
                                <option value="68190_CIMITARRA">CIMITARRA - SANTANDER</option>
                                <option value="68207_CONCEPCION">CONCEPCION - SANTANDER</option>
                                <option value="68209_CONFINES">CONFINES - SANTANDER</option>
                                <option value="68211_CONTRATACION">CONTRATACION - SANTANDER</option>
                                <option value="68217_COROMORO">COROMORO - SANTANDER</option>
                                <option value="68229_CURITI">CURITI - SANTANDER</option>
                                <option value="68235_EL CARMEN">EL CARMEN - SANTANDER</option>
                                <option value="68245_EL GUACAMAYO">EL GUACAMAYO - SANTANDER</option>
                                <option value="68250_EL PENON">EL PENON - SANTANDER</option>
                                <option value="68255_EL PLAYON">EL PLAYON - SANTANDER</option>
                                <option value="68264_ENCINO">ENCINO - SANTANDER</option>
                                <option value="68266_ENCISO">ENCISO - SANTANDER</option>
                                <option value="68271_FLORIAN">FLORIAN - SANTANDER</option>
                                <option value="68276_FLORIDABLANCA">FLORIDABLANCA - SANTANDER</option>
                                <option value="68296_GALAN">GALAN - SANTANDER</option>
                                <option value="68298_GAMBITA">GAMBITA - SANTANDER</option>
                                <option value="68307_GIRON">GIRON - SANTANDER</option>
                                <option value="68318_GUACA">GUACA - SANTANDER</option>
                                <option value="68320_GUADALUPE">GUADALUPE - SANTANDER</option>
                                <option value="68322_GUAPOTA">GUAPOTA - SANTANDER</option>
                                <option value="68324_GUAVATA">GUAVATA - SANTANDER</option>
                                <option value="68327_GUEPSA">GUEPSA - SANTANDER</option>
                                <option value="68344_HATO">HATO - SANTANDER</option>
                                <option value="68368_JESUS MARIA">JESUS MARIA - SANTANDER</option>
                                <option value="68370_JORDAN">JORDAN - SANTANDER</option>
                                <option value="68377_LA BELLEZA">LA BELLEZA - SANTANDER</option>
                                <option value="68385_LANDAZURI">LANDAZURI - SANTANDER</option>
                                <option value="68397_LA PAZ">LA PAZ - SANTANDER</option>
                                <option value="68406_LEBRIJA">LEBRIJA - SANTANDER</option>
                                <option value="68418_LOS SANTOS">LOS SANTOS - SANTANDER</option>
                                <option value="68425_MACARAVITA">MACARAVITA - SANTANDER</option>
                                <option value="68432_MALAGA">MALAGA - SANTANDER</option>
                                <option value="68444_MATANZA">MATANZA - SANTANDER</option>
                                <option value="68464_MOGOTES">MOGOTES - SANTANDER</option>
                                <option value="68468_MOLAGAVITA">MOLAGAVITA - SANTANDER</option>
                                <option value="68498_OCAMONTE">OCAMONTE - SANTANDER</option>
                                <option value="68500_OIBA">OIBA - SANTANDER</option>
                                <option value="68502_ONZAGA">ONZAGA - SANTANDER</option>
                                <option value="68522_PALMAR">PALMAR - SANTANDER</option>
                                <option value="68524_PALMAS DEL SOCORRO">PALMAS DEL SOCORRO - SANTANDER</option>
                                <option value="68533_PARAMO">PARAMO - SANTANDER</option>
                                <option value="68547_PIEDECUESTA">PIEDECUESTA - SANTANDER</option>
                                <option value="68549_PINCHOTE">PINCHOTE - SANTANDER</option>
                                <option value="68572_PUENTE NACIONAL">PUENTE NACIONAL - SANTANDER</option>
                                <option value="68573_PUERTO PARRA">PUERTO PARRA - SANTANDER</option>
                                <option value="68575_PUERTO WILCHES">PUERTO WILCHES - SANTANDER</option>
                                <option value="68615_RIONEGRO">RIONEGRO - SANTANDER</option>
                                <option value="68655_SABANA DE TORRES">SABANA DE TORRES - SANTANDER</option>
                                <option value="68669_SAN ANDRES">SAN ANDRES - SANTANDER</option>
                                <option value="68673_SAN BENITO">SAN BENITO - SANTANDER</option>
                                <option value="68679_SAN GIL">SAN GIL - SANTANDER</option>
                                <option value="68682_SAN JOAGUIN">SAN JOAQUIN - SANTANDER</option>
                                <option value="68684_SAN JOSE DE MIRANDA">SAN JOSE DE MIRANDA - SANTANDER</option>
                                <option value="68686_SAN MIGUEL">SAN MIGUEL - SANTANDER</option>
                                <option value="68689_SAN VICENTE DE CHUCURI">SAN VICENTE DE CHUCURI - SANTANDER</option>
                                <option value="68705_SANTA BARBARA">SANTA BARBARA - SANTANDER</option>
                                <option value="68720_SANTA HELENA DEL OPON">SANTA HELENA DEL OPON - SANTANDER</option>
                                <option value="68745_SIMACOTA">SIMACOTA - SANTANDER</option>
                                <option value="68755_SOCORRO">SOCORRO - SANTANDER</option>
                                <option value="68770_SUAITA">SUAITA - SANTANDER</option>
                                <option value="68773_SUCRE">SUCRE - SANTANDER</option>
                                <option value="68780_SURATA">SURATA - SANTANDER</option>
                                <option value="68820_TONA">TONA - SANTANDER</option>
                                <option value="68855_VALLE DE SAN JOSE">VALLE DE SAN JOSE - SANTANDER</option>
                                <option value="68861_VELEZ">VELEZ - SANTANDER</option>
                                <option value="68867_VETAS">VETAS - SANTANDER</option>
                                <option value="68872_VILLANUEVA">VILLANUEVA - SANTANDER</option>
                                <option value="68895_ZAPATOCA">ZAPATOCA - SANTANDER</option>
                                <option value="70001_SINCELEJO">SINCELEJO - SUCRE</option>
                                <option value="70110_BUENAVISTA">BUENAVISTA - SUCRE</option>
                                <option value="70124_CAIMITO">CAIMITO - SUCRE</option>
                                <option value="70204_COLOSO">COLOSO - SUCRE</option>
                                <option value="70215_COROZAL">COROZAL - SUCRE</option>
                                <option value="70221_COVENAS">COVENAS - SUCRE</option>
                                <option value="70230_CHALAN">CHALAN - SUCRE</option>
                                <option value="70233_EL ROBLE">EL ROBLE - SUCRE</option>
                                <option value="70235_GALERAS">GALERAS - SUCRE</option>
                                <option value="70265_GUARANDA">GUARANDA - SUCRE</option>
                                <option value="70400_LA UNION">LA UNION - SUCRE</option>
                                <option value="70418_LOS PALMITOS">LOS PALMITOS - SUCRE</option>
                                <option value="70429_MAJAGUAL">MAJAGUAL - SUCRE</option>
                                <option value="70473_MORROA">MORROA - SUCRE</option>
                                <option value="70508_OVEJAS">OVEJAS - SUCRE</option>
                                <option value="70523_PALMITO">PALMITO - SUCRE</option>
                                <option value="70670_SAMPUES">SAMPUES - SUCRE</option>
                                <option value="70678_SAN BENITO ABAD">SAN BENITO ABAD - SUCRE</option>
                                <option value="70702_SAN JUAN DE BETULIA">SAN JUAN DE BETULIA - SUCRE</option>
                                <option value="70708_SAN MARCOS">SAN MARCOS - SUCRE</option>
                                <option value="70713_SAN ONOFRE">SAN ONOFRE - SUCRE</option>
                                <option value="70717_SAN PEDRO">SAN PEDRO - SUCRE</option>
                                <option value="70742_SINCE">SINCE - SUCRE</option>
                                <option value="70771_SUCRE">SUCRE - SUCRE</option>
                                <option value="70820_TOLU">TOLU - SUCRE</option>
                                <option value="70823_TOLUVIEJO">TOLUVIEJO - SUCRE</option>
                                <option value="73001_IBAGUE">IBAGUE - TOLIMA</option>
                                <option value="73024_ALPUJARRA">ALPUJARRA - TOLIMA</option>
                                <option value="73026_ALVARADO">ALVARADO - TOLIMA</option>
                                <option value="73030_AMBALEMA">AMBALEMA - TOLIMA</option>
                                <option value="73043_ANZOATEGUI">ANZOATEGUI - TOLIMA</option>
                                <option value="73055_ARMERO GUAYABAL">ARMERO GUAYABAL - TOLIMA</option>
                                <option value="73067_ATACO">ATACO - TOLIMA</option>
                                <option value="73124_CAJAMARCA">CAJAMARCA - TOLIMA</option>
                                <option value="73148_CARMEN DE APICALA">CARMEN DE APICALA - TOLIMA</option>
                                <option value="73152_CASABIANCA">CASABIANCA - TOLIMA</option>
                                <option value="73168_CHAPARRAL">CHAPARRAL - TOLIMA</option>
                                <option value="73200_COELLO">COELLO - TOLIMA</option>
                                <option value="73217_COYAIMA">COYAIMA - TOLIMA</option>
                                <option value="73226_CUNDAY">CUNDAY - TOLIMA</option>
                                <option value="73236_DOLORES">DOLORES - TOLIMA</option>
                                <option value="73268_ESPINAL">ESPINAL - TOLIMA</option>
                                <option value="73270_FALAN">FALAN - TOLIMA</option>
                                <option value="73275_FLANDES">FLANDES - TOLIMA</option>
                                <option value="73283_FRESNO">FRESNO - TOLIMA</option>
                                <option value="73319_GUAMO">GUAMO - TOLIMA</option>
                                <option value="73347_HERVEO">HERVEO - TOLIMA</option>
                                <option value="73349_HONDA">HONDA - TOLIMA</option>
                                <option value="73352_ICONONZO">ICONONZO - TOLIMA</option>
                                <option value="73408_LERIDA">LERIDA - TOLIMA</option>
                                <option value="73411_LIBANO">LIBANO - TOLIMA</option>
                                <option value="73443_MARIQUITA">MARIQUITA - TOLIMA</option>
                                <option value="73449_MELGAR">MELGAR - TOLIMA</option>
                                <option value="73461_MURILLO">MURILLO - TOLIMA</option>
                                <option value="73483_NATAGAIMA">NATAGAIMA - TOLIMA</option>
                                <option value="73504_ORTEGA">ORTEGA - TOLIMA</option>
                                <option value="73502_PALOCABILDO">PALOCABILDO - TOLIMA</option>
                                <option value="73547_PIEDRAS">PIEDRAS - TOLIMA</option>
                                <option value="73555_PLANADAS">PLANADAS - TOLIMA</option>
                                <option value="73563_PRADO">PRADO - TOLIMA</option>
                                <option value="73585_PURIFICACION">PURIFICACION - TOLIMA</option>
                                <option value="73616_RIOBLANCO">RIOBLANCO - TOLIMA</option>
                                <option value="73622_RONCESVALLES">RONCESVALLES - TOLIMA</option>
                                <option value="73624_ROVIRA">ROVIRA - TOLIMA</option>
                                <option value="73671_SALDAÑA">SALDAÑA - TOLIMA</option>
                                <option value="73675_SAN ANTONIO">SAN ANTONIO - TOLIMA</option>
                                <option value="73678_SAN LUIS">SAN LUIS - TOLIMA</option>
                                <option value="73686_SANTA ISABEL">SANTA ISABEL - TOLIMA</option>
                                <option value="73770_SUAREZ">SUAREZ - TOLIMA</option>
                                <option value="73854_VALLE DE SAN JUAN">VALLE DE SAN JUAN - TOLIMA</option>
                                <option value="73861_VENADILLO">VENADILLO - TOLIMA</option>
                                <option value="73870_VILLAHERMOSA">VILLAHERMOSA - TOLIMA</option>
                                <option value="73873_VILLARRICA">VILLARRICA - TOLIMA</option>
                                <option value="73993_HERRERA">HERRERA - TOLIMA</option>
                                <option value="73997_SANTIAGO PEREZ">SANTIAGO PEREZ - TOLIMA</option>
                                <option value="76001_CALI">CALI - VALLE</option>
                                <option value="76020_ALCALA">ALCALA - VALLE</option>
                                <option value="76036_ANDALUCIA">ANDALUCIA - VALLE</option>
                                <option value="76041_ANSERMANUEVO">ANSERMANUEVO - VALLE</option>
                                <option value="76054_ARGELIA">ARGELIA - VALLE</option>
                                <option value="76100_BOLIVAR">BOLIVAR - VALLE</option>
                                <option value="76109_BUENAVENTURA">BUENAVENTURA - VALLE</option>
                                <option value="76111_BUGA">BUGA - VALLE</option>
                                <option value="76113_BUGALAGRANDE">BUGALAGRANDE - VALLE</option>
                                <option value="76122_CAICEDONIA">CAICEDONIA - VALLE</option>
                                <option value="76126_CALIMA">CALIMA - VALLE</option>
                                <option value="76130_CANDELARIA">CANDELARIA - VALLE</option>
                                <option value="76147_CARTAGO">CARTAGO - VALLE</option>
                                <option value="76233_DAGUA">DAGUA - VALLE</option>
                                <option value="76243_EL AGUILA">EL AGUILA - VALLE</option>
                                <option value="76246_EL CAIRO">EL CAIRO - VALLE</option>
                                <option value="76248_EL CERRITO">EL CERRITO - VALLE</option>
                                <option value="76250_EL DOVIO">EL DOVIO - VALLE</option>
                                <option value="76275_FLORIDA">FLORIDA - VALLE</option>
                                <option value="76306_GINEBRA">GINEBRA - VALLE</option>
                                <option value="76318_GUACARI">GUACARI - VALLE</option>
                                <option value="76364_JAMUNDI">JAMUNDI - VALLE</option>
                                <option value="76377_LA CUMBRE">LA CUMBRE - VALLE</option>
                                <option value="76400_LA UNION">LA UNION - VALLE</option>
                                <option value="76403_LA VICTORIA">LA VICTORIA - VALLE</option>
                                <option value="76497_OBANDO">OBANDO - VALLE</option>
                                <option value="76520_PALMIRA">PALMIRA - VALLE</option>
                                <option value="76563_PRADERA">PRADERA - VALLE</option>
                                <option value="76606_RESTREPO">RESTREPO - VALLE</option>
                                <option value="76616_RIOFRIO">RIOFRIO - VALLE</option>
                                <option value="76622_ROLDANILLO">ROLDANILLO - VALLE</option>
                                <option value="76670_SAN PEDRO">SAN PEDRO - VALLE</option>
                                <option value="76736_SEVILLA">SEVILLA - VALLE</option>
                                <option value="76823_TORO">TORO - VALLE</option>
                                <option value="76828_TRUJILLO">TRUJILLO - VALLE</option>
                                <option value="76834_TULUA">TULUA - VALLE</option>
                                <option value="76845_ULLOA">ULLOA - VALLE</option>
                                <option value="76863_VERSALLES">VERSALLES - VALLE</option>
                                <option value="76869_VIJES">VIJES - VALLE</option>
                                <option value="76890_YOTOCO">YOTOCO - VALLE</option>
                                <option value="76892_YUMBO">YUMBO - VALLE</option>
                                <option value="76895_ZARZAL">ZARZAL - VALLE</option>
                                <option value="81001_ARAUCA">ARAUCA - ARAUCA</option>
                                <option value="81065_ARAUQUITA">ARAUQUITA - ARAUCA</option>
                                <option value="81022_CRAVO NORTE">CRAVO NORTE - ARAUCA</option>
                                <option value="81300_FORTUL">FORTUL - ARAUCA</option>
                                <option value="81591_PUERTO RENDON">PUERTO RONDON - ARAUCA</option>
                                <option value="81736_SARAVENA">SARAVENA - ARAUCA</option>
                                <option value="81794_TAME">TAME - ARAUCA</option>
                                <option value="85001_YOPAL">YOPAL - CASANARE</option>
                                <option value="85010_AGUAZUL">AGUAZUL - CASANARE</option>
                                <option value="85015_CHAMEZA">CHAMEZA - CASANARE</option>
                                <option value="85125_HATO COROZAL">HATO COROZAL - CASANARE</option>
                                <option value="85136_LA SALINA">LA SALINA - CASANARE</option>
                                <option value="85139_MANI">MANI - CASANARE</option>
                                <option value="85162_MONTERREY">MONTERREY - CASANARE</option>
                                <option value="85225_NUNCHIA">NUNCHIA - CASANARE</option>
                                <option value="85230_OROCUE">OROCUE - CASANARE</option>
                                <option value="85250_PAZ DE ARIPORO">PAZ DE ARIPORO - CASANARE</option>
                                <option value="85263_PORE">PORE - CASANARE</option>
                                <option value="85279_RECETOR">RECETOR - CASANARE</option>
                                <option value="85300_SABANALARGA">SABANALARGA - CASANARE</option>
                                <option value="85315_SACAMA">SACAMA - CASANARE</option>
                                <option value="85325_SAN LUIS DE PALENQUE">SAN LUIS DE PALENQUE - CASANARE</option>
                                <option value="85400_TAMARA">TAMARA - CASANARE</option>
                                <option value="85410_TAURAMENA">TAURAMENA - CASANARE</option>
                                <option value="85430_TRINIDAD">TRINIDAD - CASANARE</option>
                                <option value="85440_VILLANUEVA">VILLANUEVA - CASANARE</option>
                                <option value="86001_MOCOA">MOCOA - PUTUMAYO</option>
                                <option value="86219_COLON">COLON - PUTUMAYO</option>
                                <option value="86320_ORITO">ORITO - PUTUMAYO</option>
                                <option value="86568_PUERTO ASIS">PUERTO ASIS - PUTUMAYO</option>
                                <option value="86569_PUERTO CAICEDO">PUERTO CAICEDO - PUTUMAYO</option>
                                <option value="86571_PUERTO GUZMAN">PUERTO GUZMAN - PUTUMAYO</option>
                                <option value="86573_PUERTO LEGUIZAMO">PUERTO  LEGUIZAMO - PUTUMAYO</option>
                                <option value="86749_SIBUNDOY">SIBUNDOY - PUTUMAYO</option>
                                <option value="86755_SAN FRANCISCO">SAN FRANCISCO - PUTUMAYO</option>
                                <option value="86757_SAN MIGUEL">SAN MIGUEL - PUTUMAYO</option>
                                <option value="86760_SANTIAGO">SANTIAGO - PUTUMAYO</option>
                                <option value="86865_VALLE GUAMUEZ">VALLE GUAMUEZ - PUTUMAYO</option>
                                <option value="86885_VILLAGARZON">VILLAGARZON - PUTUMAYO</option>
                                <option value="88001_SAN ANDRES">SAN ANDRES - SAN ANDRES</option>
                                <option value="88564_PROVIDENCIA">PROVIDENCIA - SAN ANDRES</option>
                                <option value="91001_LETICIA">LETICIA - AMAZONAS</option>
                                <option value="91263_EL ENCANTO">EL ENCANTO - AMAZONAS</option>
                                <option value="91405_LA CHORRERA">LA CHORRERA - AMAZONAS</option>
                                <option value="91407_LA PEDRERA">LA PEDRERA - AMAZONAS</option>
                                <option value="91430_LA VICTORIA">LA VICTORIA - AMAZONAS</option>
                                <option value="91460_MIRITI-PARANA">MIRITI-PARANA - AMAZONAS</option>
                                <option value="91530_PUERTO ALEGRIA">PUERTO ALEGRIA - AMAZONAS</option>
                                <option value="91536_PUERTO ARICA">PUERTO ARICA - AMAZONAS</option>
                                <option value="91540_PUERTO NARINO">PUERTO NARINO - AMAZONAS</option>
                                <option value="91669_PTO SANTANDER">PTO SANTANDER - AMAZONAS</option>
                                <option value="91798_TARAPACA">TARAPACA - AMAZONAS</option>
                                <option value="94001_INIRIDA">INIRIDA - GUAINIA</option>
                                <option value="94343_GUAVIARE">GUAVIARE - GUAINIA</option>
                                <option value="94663_MAPIRIPANA">MAPIRIPANA - GUAINIA</option>
                                <option value="94883_SAN FELIPE">SAN FELIPE - GUAINIA</option>
                                <option value="94884_PUERTO COLOMBIA">PUERTO COLOMBIA - GUAINIA</option>
                                <option value="94885_LA GUADALUPE">LA GUADALUPE - GUAINIA</option>
                                <option value="94886_CACAHUAL">CACAHUAL - GUAINIA</option>
                                <option value="94887_PANA PANA">PANA PANA - GUAINIA</option>
                                <option value="94888_MORICHAL">MORICHAL - GUAINIA</option>
                                <option value="95001_SAN JOSE DEL GUAVIARE">SAN JOSE DEL GUAVIARE - GUAVIARE</option>
                                <option value="95015_CALAMAR">CALAMAR - GUAVIARE</option>
                                <option value="95025_EL RETORNO">EL RETORNO - GUAVIARE</option>
                                <option value="95200_MIRAFLORES">MIRAFLORES - GUAVIARE</option>
                                <option value="95220_MORICHAL">MORICHAL - GUAVIARE</option>
                                <option value="97001_MITU">MITU - VAUPES</option>
                                <option value="97161_CARURU">CARURU - VAUPES</option>
                                <option value="97511_PACOA">PACOA - VAUPES</option>
                                <option value="97666_TARAIRA">TARAIRA - VAUPES</option>
                                <option value="97777_PAPUNAUA">PAPUNAUA - VAUPES</option>
                                <option value="97889_YAVARATE">YAVARATE - VAUPES</option>
                                <option value="99001_PUERTO CARRENO">PUERTO CARRENO - VICHADA</option>
                                <option value="99524_LA PRIMAVERA">LA PRIMAVERA - VICHADA</option>
                                <option value="99572_SANTA RITA">SANTA RITA - VICHADA</option>
                                <option value="99624_SANTA ROSALIA">SANTA ROSALIA - VICHADA</option>
                                <option value="99760_SAN JOSE DE OCUNE">SAN JOSE DE OCUNE - VICHADA</option>
                                <option value="99773_CUMARIBO">CUMARIBO - VICHADA</option>

                              </select>
                              <i className="far fa-list-alt" />
                            </div>  
                          </InputGroup>
                          <InputGroup className="input-group-alternative mt-3 mb-3">
                                
                            <div className="inputs-icons-borderbott">
                              <Input
                                required
                                maxLength={30}
                                placeholder="Alias"
                                type="text"
                                onChange={NicknameChange}
                                style={{fontSize:"14px",border:"none", width:"250px",height:"33px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                              />
                              <i className="fas fa-id-card" />
                            </div>  
                          </InputGroup>
                          <button
                            type="submit"
                            //onClick={() => BuildAccount()}
                            className="my-btn bg-green text-white btn shadow btn-rounded btn-block btn-lg mr-auto ml-auto"
                            style={{width:"50%"}}
                          >
                            Continuar
                          </button>
                        </form>
                        </DivStep>
                        <DivStep className="m-1">
                          <div className="text-center m-2">
                            <h2 class="ml-2">
                              {" "}
                              Verifica los datos de tu Contacto
                            </h2>
                            {console.log("datos de contacto  " + auxBuildContact)}
                          </div>
                          <div
                            className="card p-4 m-4 shadow"
                            style={{
                              listStyle: "none",
                              padding: 0 + "px",
                              margin: 5 + "px",
                            }}
                          >
                            <ul
                              className
                              style={{
                                listStyle: "none",
                                padding: 0 + "px",
                                margin: 5 + "px",
                              }}
                            >
                              <div className="text-center m-2">
                                <h2 class="ml-2"> Contacto</h2>
                              </div>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight: 1.08,
                                  }}
                                >
                                  Tipo de Identificación
                                </p>
                                <p style={{ textAlign: "right", margin: 0 }}>
                                  {contact.tid == 1? "Cedula de ciudadanía": contact.tid == 2? "Tarjeta de Identidad": contact.tid == 3? "NIT": contact.tid == 4? "Pasaporte":contact.tid == 5?"Carnet Diplomático":contact.tid == 6?"Fideicomiso": "Registro Civil de Nacimiento"}
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight: 1.08,
                                  }}
                                >
                                  Número de Identificación
                                </p>
                                <p style={{ textAlign: "right", margin: 0 }}>
                                  {contact.nid}
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  borderBottom: "1px solid #acbac9",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight: 1.08,
                                  }}
                                >
                                  Nombre
                                </p>
                                <p style={{ textAlign: "right", margin: 0 }}>
                                  {contact.name}
                                </p>
                              </li>
                              <div className="text-center m-4">
                                <h2 class="ml-2"> Cuenta</h2>
                              </div>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight: 1.08,
                                  }}
                                >
                                  Tipo de Producto
                                </p>
                                <p style={{ textAlign: "right", margin: 0 }}>
                                   {account.accountType == 1? "Cuenta de ahorros": account.accountType == 3? "Cuenta corriente":""}
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight: 1.08,
                                  }}
                                >
                                  Número
                                </p>
                                <p style={{ textAlign: "right", margin: 0 }}>
                                  {account.accountNumber}
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight: 1.08,
                                  }}
                                >
                                  Banco
                                </p>
                                <p style={{ textAlign: "right", margin: 0 }}>
                                  {account.bank}
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight: 1.08,
                                  }}
                                >
                                  Ciudad
                                </p>
                                <p style={{ textAlign: "right", margin: 0 }}>
                                  {account.city}
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight: 1.08,
                                  }}
                                >
                                  Alias
                                </p>
                                <p style={{ textAlign: "right", margin: 0 }}>
                                  {account.nickname}
                                </p>
                              </li>
                            </ul>
                          </div>
                          <button
                            onClick={() => AddRelatedAccount()}
                            style={{width:"50%"}}
                            className="my-btn bg-green text-white btn shadow btn-rounded btn-block btn-lg mt-3 mb-5 mr-auto ml-auto"
                          >
                            Crear Contacto
                          </button>
                          <Alerts data={listAlert}></Alerts>
                        </DivStep>
                      </DivStepper>
                    </Col>
                    <Col xl="3" lg="2"></Col>
                  </Row>
                </Container>
              </TabPane>
              <TabPane tabId="tabs2" className="" key="tab-pane2">
                <Container fluid key="container-tab">
                  <Row key="row-step2">
                    <Col xl="3" lg="2"></Col>

                    <Col xl="6" lg="8">
                      <div className="text-center m-4">
                        <h2 class="ml-2"> Contactos Inscritos </h2>
                      </div>
                      <RelatedAccounts data={relatedAccounts}></RelatedAccounts>
                      <Modal
                          className="modal-dialog-centered"
                          contentClassName=""
                          isOpen={cancelationEliminaModal}
                          toggle={() => setCancelationEliminaModal(!cancelationEliminaModal)}
                        >
                          <div className="p-4">
                          <div onClick={ejecutasalirCancelationEliminaModal} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                                    <h1 style={{margin:"-15px -10px 0px 0px",fontSize:"20px"}}>
                                        <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
                                          <img
                                            className=""
                                            src={
                                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo.png").default
                                            }/>
                                            </span></h1>
                                </div>
                            <div class="my-modal-header">
                              <img alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/cancel.svg").default} />
                              <div class="header-title">
                                <h5 class="avv-title-bold">¿Quieres eliminar el contacto?</h5>
                                <p class="header-subtitle">La información que has ingresado se borrará.</p>
                              </div>
                            </div>
                            <div class="my-modal-footer pt-2">
                              <button class="btn bg-white text-green shadow" type="button" onClick={() => {setCancelationEliminaModal(false)}}> No, volver </button>
                              <button class="my-btn btn bg-green text-white shadow" type="button" onClick={() => {eliminaContacto();setCancelationEliminaModal(false)}}> SÍ, ELIMINAR </button>
                            </div>
                            <Alerts data={listAlert}></Alerts> 
                          </div>
                        </Modal>
                        <Modal
                          className="modal-dialog-centered"
                          contentClassName="bg-transparent shadow-none"
                          isOpen={isLoading}
                        >
             
                              <div tabindex="-1" style={{ position: "relative;" ,  "z-index": "1050" ,  display : "block" , width:"100%", height: "80vh" }}>
                                    <div style={{ "text-align": "center", top: "50%", position: "relative"  }}>
                                        <img style={{height:"100px", }} src={require("../../assets/img/icons/Loader-01.gif").default}></img>
                                    </div>
                                    <div class="modal-backdrop fade show"></div>
                                </div>
                            
                      </Modal>
                      
                      <Modal
                        className="modal-dialog-centered"
                        contentClassName=""
                        isOpen={exitoElimina}
                        toggle ={() => setExitoElimina(!exitoElimina)}
                        //toggle={() => setResultModal(!cancelationModal)}
                      >
                        <div className="p-4">
                        <div onClick={ejecutasalirEliminaModal} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                                              <h1 style={{margin:"-15px -10px 0px 0px",fontSize:"20px"}}>
                                                  <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
                                                    <img
                                                      className=""
                                                      src={
                                                          require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo.png").default
                                                      }/>
                                                      </span></h1>
                                          </div>
                          <div class="my-modal-header">
                            <img
                              alt="delete-icon"
                              class="my-header-brand-img"
                              src={exitoCreacion}
                            />
                            <div class="header-title">
                              <h5 class="avv-title-bold">Proceso exitoso</h5>
                              <p class="header-subtitle">
                                <span>El contacto fue eliminado con éxito.</span> 
                              </p>
                            </div>
                          </div>
                          <div class="my-modal-footer pt-2">
                            <button
                              class="btn bg-green text-white"
                              type="button"
                              onClick={() => { terminaEliminaContact() }}
                            >
                              Continuar
                            </button>
                          </div>
                        </div>
                      </Modal>
                    </Col>
                    <Col xl="3" lg="2"></Col>
                  </Row>
                </Container>
              </TabPane>
              <TabPane tabId="tabs3" className="" key="tab-pane2">
                <Container fluid key="container-tab">
                  <Row key="row-step2">
                    <Col xl="3" lg="2"></Col>

                    <Col xl="12" lg="8">
                      {/* <div className="text-center m-4">
                        <h2 class="ml-2"> Cargue Masivo Contactos </h2>
                      </div> */}
                      <MassiveContactCharge cancel={cancelarMasivo} account={""}></MassiveContactCharge>
                      
                    </Col>
                    <Col xl="3" lg="2"></Col>
                  </Row>
                </Container>
              </TabPane>
              <TabPane tabId="tabs4" className="" key="tab-pane4">
                <Container fluid key="container-tab">
                  <Row key="row-step2">
                    <Col xl="3" lg="2"></Col>

                    <Col xl="12" lg="8">
                      {/* <div className="text-center m-4">
                        <h2 class="ml-2"> Cargue Masivo Contactos </h2>
                      </div> */}
                      <ModificarContacto contact={infContModif} typesId={tidelec} cancelaMC={infContCancel}></ModificarContacto>
                    </Col>
                    <Col xl="3" lg="2"></Col>
                  </Row>
                </Container>
              </TabPane>
            </TabContent>
          </Container>
        </>
      );
    }
  }

  return (
    <>
      <NavsTransfer></NavsTransfer>
    </>
  );
}

export default Contacts;
